<template>
  <div class="app-main-content">
    <div class="grid-view">
      <div class="main-content">
        <div class="operations">
          <div class="triggers">
            <div class="edi-triggers">
              <div class="query-toggle" @click="expandSearchForm=!expandSearchForm">
                <i v-show="!expandSearchForm" class="el-icon-arrow-left down" />
                <i v-show="expandSearchForm" class="el-icon-arrow-left up" />
              </div>
              <el-input v-show="!expandSearchForm" v-model="searchConditions.jobNo" :placeholder="$t('SeaExport.Prompt1')" />
              <el-menu mode="horizontal" active-text-color="#909399" @select="onMenuSelect">
                <el-menu-item index="query">
                  <template slot="title">
                    <el-button no="1" type="primary">{{ $t('common.btn.query') }}</el-button>
                  </template>
                </el-menu-item>
                <el-menu-item v-show="expandSearchForm" index="reset">
                  <template slot="title">
                    <el-button no="2" type="warning">{{ $t('common.btn.reset') }}</el-button>
                  </template>
                </el-menu-item>
                <!--  订舱  -->
                <el-submenu index="booking">
                  <template slot="title">
                    <el-button-group>
                      <el-button no="3" type="primary" size="small">{{ $t('SeaExport.Booking') }}</el-button>
                      <el-button no="4" type="primary" class="attach-caret-button">
                        <i class="el-icon-arrow-down" />
                      </el-button>
                    </el-button-group>
                  </template>
                  <el-menu-item v-if="oneKeyBookingEnable && $checkPermission(['button_EDI_oneKeyBooking'])" index="oneKeyBooking">{{ $t('CargoMsg.Cargo_OneKeyBooking') }}</el-menu-item>
                  <el-submenu index="origin">
                    <template slot="title">{{ $t('SeaExport.Original') }}</template>
                    <el-menu-item no="5" index="API" :disabled="!btnStatus.bookingBtn || (!(configMap.get('BookingEDIApiOpen') !== '0') && !isHZ)">API</el-menu-item>
                    <el-menu-item no="6" index="FTP" :disabled="!btnStatus.bookingBtn || isHZ">FTP</el-menu-item>
                    <el-menu-item no="rpa1" index="RPA1" :disabled="!btnStatus.bookingBtn || isHZ">RPA</el-menu-item>
                  </el-submenu>
                  <el-submenu index="correct">
                    <template slot="title">{{ $t('SeaExport.Correct') }}</template>
                    <el-menu-item no="7" index="FTP" :disabled="!btnStatus.bookingBtn || isHZ">FTP</el-menu-item>
                    <el-menu-item no="8" index="API" :disabled="!btnStatus.bookingBtn || !(configMap.get('BookingEDIApiOpen') !== '0') || isHZ">API</el-menu-item>
                  </el-submenu>
                  <el-menu-item v-show="configMap.get('SEAllowReceiptImport') === '1'" no="9" index="import" :disabled="!btnStatus.bookingBtn">{{ $t('SeaExport.ReceiptImport') }}</el-menu-item>
                </el-submenu>
                <!--  提单  -->
                <el-submenu v-permission="['button_EDI_billOfLading']" index="bl" :disabled="!btnStatus.blBtn">
                  <template slot="title">
                    <el-button-group>
                      <el-button no="10" type="primary" size="small">{{ $t('SeaExport.Bl') }}</el-button>
                      <el-button no="11" type="primary" class="attach-caret-button">
                        <i class="el-icon-arrow-down" />
                      </el-button>
                    </el-button-group>
                  </template>
                  <el-submenu index="origin">
                    <template slot="title">{{ $t('SeaExport.Original') }}</template>
                    <el-menu-item no="12" index="API" :disabled="!(configMap.get('BillEDIApiOpen') !== '0')">API</el-menu-item>
                    <el-menu-item no="13" index="FTP">FTP</el-menu-item>
                  </el-submenu>
                  <el-submenu index="correct">
                    <template slot="title">{{ $t('SeaExport.Correct') }}</template>
                    <el-menu-item no="14" index="FTP">FTP</el-menu-item>
                    <el-menu-item no="15" index="API" :disabled="!(configMap.get('BillEDIApiOpen') !== '0')">API</el-menu-item>
                  </el-submenu>
                  <el-menu-item no="CargoDocExtend" index="CargoDocExtend">{{ $t('SeaExport.EdiEuBolInfo') }}</el-menu-item>
                </el-submenu>
                <!--  VGM -->
                <el-submenu index="vgm" :disabled="!btnStatus.vgmBtn">
                  <template slot="title">
                    <el-button-group>
                      <el-button no="16" type="primary" size="small">VGM</el-button>
                      <el-button no="17" type="primary" class="attach-caret-button">
                        <i class="el-icon-arrow-down" />
                      </el-button>
                    </el-button-group>
                  </template>
                  <el-menu-item no="18" index="origin">{{ $t('SeaExport.Original') }}</el-menu-item>
                  <el-menu-item no="19" index="correct">{{ $t('SeaExport.Correct') }}</el-menu-item>
                </el-submenu>
                <!--  海外代理预报  -->
                <el-submenu index="sham">
                  <template slot="title">
                    <el-button-group>
                      <el-button no="20" type="primary" size="small" style="width: 160px;">{{ $t('SeaExport.OverseasAgeFore') }}</el-button>
                      <el-button no="21" type="primary" class="attach-caret-button">
                        <i class="el-icon-arrow-down" />
                      </el-button>
                    </el-button-group>
                  </template>
                  <el-menu-item no="22" index="overseaAgent">{{ $t('SeaExport.OverseasAgeFore') }}</el-menu-item>
                  <el-menu-item no="23" index="cargoWise">CargoWise</el-menu-item>
                  <el-submenu index="jinYi">
                    <template slot="title">{{ $t('SeaExport.JingyiSystemForecast') }}</template>
                    <el-menu-item no="24" index="origin">{{ $t('SeaExport.Original') }}</el-menu-item>
                    <el-menu-item no="25" index="correct">{{ $t('SeaExport.Correct') }}</el-menu-item>
                    <el-menu-item no="26" index="delete">{{ $t('FileHistory.Delete') }}</el-menu-item>
                  </el-submenu>
                  <el-submenu v-permission="['button_EDI_overseasAgentForecast']" index="jcl">
                    <template slot="title">{{ $t('SeaExport.JclForecast') }}</template>
                    <el-menu-item no="JclOriginal" index="origin">{{ $t('SeaExport.Original') }}</el-menu-item>
                    <el-menu-item no="JclCorrect" index="correct">{{ $t('SeaExport.Correct') }}</el-menu-item>
                    <el-menu-item no="JclDelete" index="delete">{{ $t('FileHistory.Delete') }}</el-menu-item>
                  </el-submenu>
                </el-submenu>
                <!--  E2Open 星亚专用  -->
                <el-submenu v-show="configMap.get('ToExoSystem') === 'XY'" index="E2Open" :disabled="!btnStatus.xyE2OpenBtn">
                  <template slot="title">
                    <el-button-group>
                      <el-button no="27" type="primary" size="small">E2Open</el-button>
                      <el-button no="28" type="primary" class="attach-caret-button">
                        <i class="el-icon-arrow-down" />
                      </el-button>
                    </el-button-group>
                  </template>
                  <el-submenu index="origin">
                    <template slot="title">{{ $t('SeaExport.Original') }}</template>
                    <el-submenu index="856">
                      <template slot="title">856{{ $t('SeaExport.Message') }}</template>
                      <el-menu-item no="29" index="LTO">LTO</el-menu-item>
                      <el-menu-item no="30" index="CLP">CLP</el-menu-item>
                    </el-submenu>
                    <el-submenu index="315">
                      <template slot="title">315{{ $t('SeaExport.Message') }}</template>
                      <el-menu-item no="origin-315-EE" index="315EE">{{ $t('SeaExport.EmptyOut') }}</el-menu-item>
                      <el-menu-item no="origin-315-I" index="315I">{{ $t('SeaExport.GateIn') }}</el-menu-item>
                      <el-menu-item no="origin-315-VD" index="315VD">{{ $t('SeaExport.VesselDeparturePOL') }}</el-menu-item>
                      <el-menu-item no="origin-315-ALL" index="315ALL">{{ $t('SeaExport.SendAll') }}</el-menu-item>
                    </el-submenu>
                  </el-submenu>
                  <el-submenu index="correct">
                    <template slot="title">{{ $t('SeaExport.Correct') }}</template>
                    <el-submenu index="856">
                      <template slot="title">856{{ $t('SeaExport.Message') }}</template>
                      <el-menu-item no="32" index="LTO">LTO</el-menu-item>
                      <el-menu-item no="33" index="CLP">CLP</el-menu-item>
                    </el-submenu>
                    <el-submenu index="315">
                      <template slot="title">315{{ $t('SeaExport.Message') }}</template>
                      <el-menu-item no="correct-315-EE" index="315EE">{{ $t('SeaExport.EmptyOut') }}</el-menu-item>
                      <el-menu-item no="correct-315-I" index="315I">{{ $t('SeaExport.GateIn') }}</el-menu-item>
                      <el-menu-item no="correct-315-VD" index="315VD">{{ $t('SeaExport.VesselDeparturePOL') }}</el-menu-item>
                      <el-menu-item no="correct-315-ALL" index="315ALL">{{ $t('SeaExport.SendAll') }}</el-menu-item>
                    </el-submenu>
                  </el-submenu>
                  <el-submenu index="delete">
                    <template slot="title">{{ $t('SeaExport.Delete') }}</template>
                    <el-submenu index="856">
                      <template slot="title">856{{ $t('SeaExport.Message') }}</template>
                      <el-menu-item no="34" index="LTO">LTO</el-menu-item>
                      <el-menu-item no="35" index="CLP">CLP</el-menu-item>
                    </el-submenu>
                    <el-submenu index="315">
                      <template slot="title">315{{ $t('SeaExport.Message') }}</template>
                      <el-menu-item no="delete-315-EE" index="315EE">{{ $t('SeaExport.EmptyOut') }}</el-menu-item>
                      <el-menu-item no="delete-315-I" index="315I">{{ $t('SeaExport.GateIn') }}</el-menu-item>
                      <el-menu-item no="delete-315-VD" index="315VD">{{ $t('SeaExport.VesselDeparturePOL') }}</el-menu-item>
                      <el-menu-item no="delete-315-ALL" index="315ALL">{{ $t('SeaExport.SendAll') }}</el-menu-item>
                    </el-submenu>
                  </el-submenu>
                </el-submenu>
                <!--  安装箱 -->
                <el-menu-item no="37" index="packing" :disabled="!btnStatus.packingBtn">
                  <template slot="title">
                    <el-button no="38" type="primary">{{ $t('SeaExport.AnnPackingList') }}</el-button>
                  </template>
                </el-menu-item>
                <!--  预配舱单  -->
                <el-submenu index="preShipping" :disabled="!btnStatus.preShippingBtn">
                  <template slot="title">
                    <el-button-group>
                      <el-button no="39" type="primary" size="small">{{ $t('SeaExport.PreShippingBill') }}</el-button>
                      <el-button no="40" type="primary" class="attach-caret-button">
                        <i class="el-icon-arrow-down" />
                      </el-button>
                    </el-button-group>
                  </template>
                  <el-submenu index="origin">
                    <template slot="title">{{ $t('SeaExport.Original') }}</template>
                    <el-menu-item no="410" index="API" :disabled="!(configMap.get('PreplanEDIApiOpen') !== '0')">API</el-menu-item>
                    <el-menu-item no="41" index="FTP" :disabled="isHZ">FTP</el-menu-item>
                  </el-submenu>
                  <el-submenu index="correct">
                    <template slot="title">{{ $t('SeaExport.Correct') }}</template>
                    <el-menu-item no="42" index="FTP" :disabled="isHZ">FTP</el-menu-item>
                    <el-menu-item no="420" index="API" :disabled="!(configMap.get('PreplanEDIApiOpen') !== '0') || isHZ">API</el-menu-item>
                  </el-submenu>
                  <el-submenu index="delete">
                    <template slot="title">{{ $t('FileHistory.Delete') }}</template>
                    <el-menu-item no="43" index="FTP" :disabled="isHZ">FTP</el-menu-item>
                    <el-menu-item no="430" index="API" :disabled="!(configMap.get('PreplanEDIApiOpen') !== '0') || isHZ">API</el-menu-item>
                  </el-submenu>
                </el-submenu>
                <!--  舱单 -->
                <el-menu-item no="47" index="shipping" :disabled="!btnStatus.shippingBtn">
                  <template slot="title">
                    <el-button no="48" type="primary">{{ $t('SeaExport.ShippingBill') }}</el-button>
                  </template>
                </el-menu-item>
                <!--  反恐舱单  -->
                <el-submenu index="afr">
                  <template slot="title">
                    <el-button-group>
                      <el-button no="49" type="primary" size="small">{{ $t('SeaExport.Anti_terrorismShipping') }}</el-button>
                      <el-button no="50" type="primary" class="attach-caret-button">
                        <i class="el-icon-arrow-down" />
                      </el-button>
                    </el-button-group>
                  </template>
                  <el-submenu index="origin_ahr">
                    <template slot="title">{{ $t('SeaExport.OriginalAHR') }}</template>
                    <el-menu-item no="51" index="API" :disabled="(configMap.get('afrSupplierConfiguration') !== 'eFreight')">API</el-menu-item>
                    <el-menu-item no="52" index="FTP" :disabled="((configMap.get('afrSupplierConfiguration') !== 'decarts') && (configMap.get('afrSupplierConfiguration') !== 'tradetech') && (configMap.get('afrSupplierConfiguration') !== 'other'))">FTP</el-menu-item>
                  </el-submenu>
                  <el-submenu index="add_chr">
                    <template slot="title">{{ $t('SeaExport.AddChr') }}</template>
                    <el-menu-item no="53" index="API" :disabled="(configMap.get('afrSupplierConfiguration') !== 'eFreight')">API</el-menu-item>
                    <el-menu-item no="54" index="FTP" :disabled="((configMap.get('afrSupplierConfiguration') !== 'decarts') && (configMap.get('afrSupplierConfiguration') !== 'tradetech') && (configMap.get('afrSupplierConfiguration') !== 'other'))">FTP</el-menu-item>
                  </el-submenu>
                  <el-submenu index="update_afr">
                    <template slot="title">{{ $t('SeaExport.CorrectAFR') }}</template>
                    <el-menu-item no="55" index="API" :disabled="(configMap.get('afrSupplierConfiguration') !== 'eFreight')">API</el-menu-item>
                    <el-menu-item no="56" index="FTP" :disabled="((configMap.get('afrSupplierConfiguration') !== 'decarts') && (configMap.get('afrSupplierConfiguration') !== 'tradetech') && (configMap.get('afrSupplierConfiguration') !== 'other'))">FTP</el-menu-item>
                  </el-submenu>
                  <el-menu-item no="57" index="format_address">{{ $t('SeaExport.AddressFormatting') }}</el-menu-item>
                </el-submenu>
                <!--  清洁舱单 -->
                <el-menu-item no="58" index="clear" :disabled="!btnStatus.clearBtn">
                  <template slot="title">
                    <el-button type="primary">{{ $t('SeaExport.CleanShipping') }}</el-button>
                  </template>
                </el-menu-item>
                <!--  提箱 -->
                <el-menu-item v-permission="['button_EDI_suitcase']" no="59" index="suitcase">
                  <template slot="title">
                    <el-button type="primary">{{ $t('SeaExport.Suitcase') }}</el-button>
                  </template>
                </el-menu-item>
                <!--  提箱 -->
                <el-menu-item v-if="isHZ" no="125" index="containerInfo">
                  <template slot="title">
                    <el-button type="primary">{{ $t('SeaExport.ContainerInfo') }}</el-button>
                  </template>
                </el-menu-item>
                <!--  GO FREIGHT  -->
                <el-submenu v-show="configMap.get('isAllowToGoFreight') === '1'" index="freight" :disabled="!btnStatus.hasGoFreight">
                  <template slot="title">
                    <el-button-group>
                      <el-button no="60" type="primary" size="small">GO FREIGHT</el-button>
                      <el-button no="61" type="primary" class="attach-caret-button">
                        <i class="el-icon-arrow-down" />
                      </el-button>
                    </el-button-group>
                  </template>
                  <el-menu-item no="62" index="send_freight">{{ $t('SeaExport.SendToGoFreight') }}</el-menu-item>
                  <el-menu-item no="63" index="look_freight">{{ $t('SeaExport.ViewSendLog') }}</el-menu-item>
                </el-submenu>
                <!--  SCFI申报  -->
                <el-submenu v-show="configMap.get('openScfiDeclare') === '1'" index="scfi">
                  <template slot="title">
                    <el-button-group>
                      <el-button no="64" type="primary" size="small">{{ $t('SeaExport.ScfiDeclare') }}</el-button>
                      <el-button no="65" type="primary" class="attach-caret-button">
                        <i class="el-icon-arrow-down" />
                      </el-button>
                    </el-button-group>
                  </template>
                  <el-submenu index="booking_price" popper-append-to-body>
                    <template slot="title">{{ $t('SeaExport.BookingFreightRate') }}</template>
                    <el-menu-item no="66" index="select_data">{{ $t('SeaExport.SelectedDataDeclaration') }}</el-menu-item>
                    <el-menu-item no="67" index="none_data">{{ $t('SeaExport.EmptySubmissionDeclaration') }}</el-menu-item>
                  </el-submenu>
                  <el-submenu index="settle_price" popper-append-to-body>
                    <template slot="title">{{ $t('SeaExport.SettlementFreightRate') }}</template>
                    <el-menu-item no="68" index="select_data">{{ $t('SeaExport.SelectedDataDeclaration') }}</el-menu-item>
                    <el-menu-item no="69" index="none_data">{{ $t('SeaExport.EmptySubmissionDeclaration') }}</el-menu-item>
                  </el-submenu>
                  <el-menu-item no="70" index="record">{{ $t('SeaExport.DeclarationRecord') }}</el-menu-item>
                </el-submenu>
                <!--  导出Excel -->
                <el-menu-item v-if="!($checkPermission(['role_hideAllExports']) && !$store.getters.isAdmin)" index="export">
                  <template slot="title">
                    <el-button no="71" type="primary">{{ $t('Payment.exportExcel') }}</el-button>
                  </template>
                </el-menu-item>
                <!--  查看历史 -->
                <el-menu-item index="history">
                  <template slot="title">
                    <el-button no="72" type="primary">{{ $t('SeaExport.ViewHistory') }}</el-button>
                  </template>
                </el-menu-item>
                <!--  99路电子装箱单  -->
                <el-submenu v-show="tenantId===100" index="electronicPacking">
                  <template slot="title">
                    <el-button-group>
                      <el-button no="73" type="primary" size="small">{{ $t('SeaExport.ElectronicPackingList') }}</el-button>
                      <el-button no="74" type="primary" class="attach-caret-button">
                        <i class="el-icon-arrow-down" />
                      </el-button>
                    </el-button-group>
                  </template>
                  <el-menu-item no="75" index="electronicPacking">{{ $t('SeaExport.ElectronicPackingList') }}</el-menu-item>
                  <el-menu-item no="76" index="history">{{ $t('SeaExport.SendHistory') }}</el-menu-item>
                </el-submenu>
              </el-menu>
            </div>
          </div>
        </div>
        <el-form v-show="expandSearchForm" :inline="true" label-width="85px" label-position="left" style="padding: 10px 0 0 5px">
          <div class="search-form">
            <el-form-item :label="$t('SeaExport.WarehouseNo2')">
              <el-input v-model="advancedSearchForm.warehouseNo" no="77" />
            </el-form-item>
            <el-form-item :label="$t('Payment.mbl')">
              <el-input v-model="advancedSearchForm.refNbr" no="78" />
            </el-form-item>
            <el-form-item :label="$t('Payment.containerNo')">
              <el-input v-model="advancedSearchForm.containerNo" no="79" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.FileNo')">
              <el-input v-model="advancedSearchForm.verificationNo" no="80" />
            </el-form-item>
            <el-form-item :label="$t('Payment.bookingNo')">
              <el-input v-model="advancedSearchForm.bookingNo" no="81" />
            </el-form-item>
            <el-form-item :label="$t('Payment.consignationCompany')">
              <cargo-advance-select
                no="82"
                filterable
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{customer:true}"
                callback-method-type="value"
                :callback-params="{key:'customerId'}"
                :default-value="advancedSearchForm.customerId||''"
                @parentCallBack="getValueFromChild"
              />
            </el-form-item>
            <el-form-item :label="$t('queryJob.bookingAgent')">
              <cargo-advance-select
                no="83"
                filterable
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{bookingAgent:true}"
                :callback-params="{key:'bookingAgent'}"
                callback-method-type="value"
                :default-value="advancedSearchForm.bookingAgent||''"
                @parentCallBack="getValueFromChild"
              />
            </el-form-item>
            <el-form-item :label="$t('Payment.destinationAgent')">
              <cargo-advance-select
                no="84"
                filterable
                :select-type="selectTypeNames.basic_data_Company"
                callback-method-type="value"
                tag-name="englishName"
                :method-params="{overseaAgent:true}"
                :callback-params="{key:'destinationAgent'}"
                :default-value="advancedSearchForm.destinationAgent||''"
                @parentCallBack="getValueFromChild"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ShippingCompany')">
              <cargo-advance-select
                no="85"
                filterable
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{seaCmp:true}"
                callback-method-type="value"
                :callback-params="{key:'carrierId'}"
                :default-value="advancedSearchForm.carrierId||''"
                @parentCallBack="getValueFromChild"
              />
            </el-form-item>
            <el-form-item :label="$t('Payment.itemNo')">
              <el-input v-model="advancedSearchForm.poNo" no="86" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PortOfLoading')">
              <cargo-advance-select
                no="87"
                filterable
                :select-type="selectTypeNames.basic_data_Seaport"
                callback-method-type="value"
                :callback-params="{key:'loadingPortCode'}"
                :default-value="advancedSearchForm.loadingPortCode||''"
                @parentCallBack="getValueFromChild"
              />
            </el-form-item>
            <el-form-item :label="$t('Payment.portOfTransfer')">
              <cargo-advance-select
                no="88"
                filterable
                :select-type="selectTypeNames.basic_data_Seaport"
                callback-method-type="value"
                :callback-params="{key:'transferPortCode'}"
                :default-value="advancedSearchForm.transferPortCode||''"
                @parentCallBack="getValueFromChild"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PortOfDischarge')">
              <cargo-advance-select
                no="89"
                filterable
                :select-type="selectTypeNames.basic_data_Seaport"
                callback-method-type="value"
                :callback-params="{key:'destinationPort'}"
                :default-value="advancedSearchForm.destinationPort||''"
                @parentCallBack="getValueFromChild"
              />
            </el-form-item>
            <el-form-item :label="$t('queryJob.dateOfDeparture')">
              <el-date-picker
                v-model="rangeDateETD"
                no="90"
                type="daterange"
                value-format="yyyy-MM-dd"
                :start-placeholder="$t('Tool.BeginDate')"
                :end-placeholder="$t('Project.EndtDate')"
              />
            </el-form-item>
            <el-form-item :label="$t('Payment.businessReferenceNumber')">
              <el-input v-model="advancedSearchForm.customerRefNo" no="91" />
            </el-form-item>
            <el-form-item :label="$t('Message.Shipper')">
              <el-input v-model="advancedSearchForm.shipper" no="92" />
            </el-form-item>
            <el-form-item :label="$t('Message.Consignee')">
              <el-input v-model="advancedSearchForm.consignee" no="93" />
            </el-form-item>
            <el-form-item label="SO NO">
              <el-input v-model="advancedSearchForm.soNo" no="94" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DateOfArrival')">
              <el-date-picker
                v-model="rangeDateETA"
                no="95"
                type="daterange"
                value-format="yyyy-MM-dd"
                :start-placeholder="$t('Tool.BeginDate')"
                :end-placeholder="$t('Project.EndtDate')"
              />
            </el-form-item>
            <el-form-item :label="$t('queryJob.shippingCompanyContractNo')">
              <el-input v-model="advancedSearchForm.scNo" no="96" />
            </el-form-item>
            <el-form-item :label="$t('Payment.vessel')">
              <cargo-advance-select
                no="97"
                filterable
                :select-type="selectTypeNames.basic_data_Vessel"
                callback-method-type="value"
                :callback-params="{key:'vessel'}"
                :default-value="advancedSearchForm.vessel||''"
                @parentCallBack="getValueFromChild"
              />
            </el-form-item>
            <el-form-item :label="$t('Payment.voyage')">
              <el-input v-model="advancedSearchForm.voyageFlight" no="98" />
            </el-form-item>
            <el-form-item :label="$t('Payment.billNo')">
              <el-input v-model="advancedSearchForm.billingNo" no="99" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.LoadingDate')">
              <el-date-picker
                v-model="rangeDateLoadingDate"
                no="100"
                type="daterange"
                value-format="yyyy-MM-dd"
                :start-placeholder="$t('Tool.BeginDate')"
                :end-placeholder="$t('Project.EndtDate')"
              />
            </el-form-item>
            <el-form-item class="form-item-300">
              <div style="display: flex">
                <el-checkbox v-model="advancedSearchForm.ams" no="101" label="AMS" />
                <el-checkbox v-model="advancedSearchForm.vgm" no="102" label="VGM" />
                <el-checkbox v-model="advancedSearchForm.contain" no="103" :label="$t('SeaExport.IncludingSCFIFreightRate')" />
                <el-checkbox v-model="advancedSearchForm.appoint" no="104" :label="$t('SeaExport.SCFIDesignatedBoxType')" />
              </div>
            </el-form-item>
            <el-form-item :label="$t('queryJob.FLCLType')">
              <el-select
                v-model="advancedSearchForm.containerLoadTypes"
                no="105"
                :placeholder="$t('common.tips.pleaseChoose')"
                multiple
                collapse-tags
                clearable
              >
                <el-option v-for="(item,index) in containerLoadTypes" :key="index" :label="isZh?item.chineseName:item.englishName" :value="item.code" />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.LocalService')">
              <el-select
                v-model="advancedSearchForm.stuffingTypes"
                no="106"
                :placeholder="$t('common.tips.pleaseChoose')"
                multiple
                collapse-tags
                clearable
              >
                <el-option v-for="item in localServices" :key="item.code" :label="isZh?item.chineseName:item.englishName" :value="item.code" />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('Payment.solicitationType')">
              <el-select v-model="advancedSearchForm.cargoSource" no="107" :placeholder="$t('common.tips.pleaseChoose')">
                <el-option v-for="item in solicitationTypes" :key="item.code" :label="isZh?item.chineseName:item.englishName" :value="item.code" />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('FileHistory.createdDate')">
              <el-date-picker
                v-model="rangeDateDateCreated"
                no="108"
                type="daterange"
                value-format="yyyy-MM-dd"
                :start-placeholder="$t('Tool.BeginDate')"
                :end-placeholder="$t('Project.EndtDate')"
              />
            </el-form-item>
            <el-form-item class="form-item-300">
              <el-checkbox v-model="advancedSearchForm.shutOut" no="109" :label="$t('SeaExport.ShutOut')" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CargoType')">
              <cargo-advance-select
                no="110"
                filterable
                cache
                :fixed-options="[{code: '', chineseName: $t('SeaExport.All')}]"
                :select-type="selectTypeNames.basic_data_CargoType"
                :method-params="{sea:true}"
                :fields="['chineseName']"
                tag-value="code"
                :default-value="advancedSearchForm.cargoType"
                callback-method-type="value"
                :callback-params="{key:'cargoType'}"
                @parentCallBack="getValueFromChild"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.MBLTransportationClause')">
              <cargo-advance-select
                no="111"
                cache
                :fixed-options="[{code: '', name: $t('SeaExport.All')}]"
                :select-type="selectTypeNames.basic_data_ShippingTerm"
                :default-value="advancedSearchForm.freightTerm"
                callback-method-type="value"
                :callback-params="{key:'freightTerm'}"
                options-width="180px"
                @parentCallBack="getValueFromChild"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PortOfDischarge')">
              <cargo-advance-select
                no="112"
                filterable
                multiple
                :select-type="selectTypeNames.basic_data_Seaport"
                callback-method-type="value"
                :callback-params="{key:'dischargingPortCodes'}"
                :default-multiple-value="advancedSearchForm.dischargingPortCodes||[]"
                @parentCallBack="getValueFromChild"
              />
            </el-form-item>
            <el-form-item :label="$t('Payment.operationDate')">
              <el-date-picker
                v-model="rangeDateCustomsDate"
                no="113"
                type="daterange"
                value-format="yyyy-MM-dd"
                :start-placeholder="$t('Tool.BeginDate')"
                :end-placeholder="$t('Project.EndtDate')"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ActualDateOfLeavingBerth')">
              <el-date-picker
                v-model="rangeDateActualUnBerthPlanDate"
                no="114"
                type="daterange"
                value-format="yyyy-MM-dd"
                :start-placeholder="$t('Tool.BeginDate')"
                :end-placeholder="$t('Project.EndtDate')"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_BookingState')">
              <cargo-advance-select
                no="bookingState"
                filterable
                multiple
                :default-multiple-value="advancedSearchForm.newBookingStates || []"
                :cache="false"
                tag-name="chineseName"
                tag-value="code"
                :filter-tag-names="['code','chineseName']"
                :static-options="JOB_BOOKING_STATES"
                @parentCallBack="p=>{advancedSearchForm.newBookingStates=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OrderChannels')">
              <el-input v-model="advancedSearchForm.salesChannel" no="salesChannel" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_BookingSendMethod')">
              <cargo-advance-select
                no="bookingSendMethod"
                filterable
                :default-value="advancedSearchForm.bookingSendMethod"
                :cache="false"
                tag-name="chineseName"
                tag-value="code"
                :filter-tag-names="['code','chineseName']"
                :static-options="BOOKING_SEND_METHODS"
                @parentCallBack="p=>{advancedSearchForm.bookingSendMethod=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_BookingTransportMode')">
              <cargo-advance-select
                no="bookingTransportMode"
                filterable
                :default-value="advancedSearchForm.bookingTransportMode"
                :cache="false"
                tag-name="chineseName"
                tag-value="code"
                :filter-tag-names="['code','chineseName']"
                :static-options="TRANSPORT_MODES"
                @parentCallBack="p=>{advancedSearchForm.bookingTransportMode=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_OriginBookingState')">
              <el-input v-model="advancedSearchForm.originBookingState" no="originBookingState" />
            </el-form-item>
          </div>
          <div class="search-form-bottom">
            <el-form-item :label="$t('Payment.sales')" label-width="36px">
              <cargo-advance-select
                no="115"
                filterable
                :select-type="selectTypeNames.basic_data_User"
                :url="url.sys.getUsersByPrivilegeDetail"
                :cache="false"
                :method-params="{'officeId': null, 'category' : 'role', 'shape' : 'sales' }"
                :callback-params="{key:'sales'}"
                callback-method-type="value"
                :default-value="advancedSearchForm.sales||''"
                @parentCallBack="getValueFromChild"
              />
            </el-form-item>
            <el-form-item :label="$t('FileHistory.operation')" label-width="55px">
              <cargo-advance-select
                no="116"
                filterable
                :select-type="selectTypeNames.basic_data_User"
                :url="url.sys.getUsersByPrivilegeDetail"
                :cache="false"
                :method-params="{'officeId': currentOfficeId, 'category' : 'role', 'shape' : 'op' }"
                :callback-params="{key:'op'}"
                callback-method-type="value"
                :default-value="advancedSearchForm.op||''"
                @parentCallBack="getValueFromChild"
              />
            </el-form-item>
            <el-form-item :label="$t('Payment.customerService')" label-width="55px">
              <cargo-advance-select
                no="117"
                filterable
                :select-type="selectTypeNames.basic_data_User"
                :url="url.sys.getUsersByPrivilegeDetail"
                :cache="false"
                :method-params="{'officeId': null, 'category' : 'role', 'shape' : 'csr' }"
                :callback-params="{key:'csr'}"
                callback-method-type="value"
                :default-value="advancedSearchForm.csr||''"
                @parentCallBack="getValueFromChild"
              />
            </el-form-item>
            <el-form-item :label="$t('queryJob.Documents')" label-width="65px">
              <cargo-advance-select
                no="118"
                filterable
                :select-type="selectTypeNames.basic_data_User"
                :url="url.sys.getUsersByPrivilegeDetail"
                :cache="false"
                :method-params="{'officeId': null, 'category' : 'role', 'shape' : 'doc'}"
                :callback-params="{key:'doc'}"
                callback-method-type="value"
                :default-value="advancedSearchForm.doc||''"
                @parentCallBack="getValueFromChild"
              />
            </el-form-item>
            <el-form-item :label="$t('queryJob.route')" label-width="36px">
              <cargo-advance-select
                no="119"
                filterable
                :select-type="selectTypeNames.basic_data_User"
                :url="url.sys.getUsersByPrivilegeDetail"
                :cache="false"
                :method-params="{'officeId': null, 'category' : 'role', 'shape' : 'sealine' }"
                :callback-params="{key:'planner'}"
                callback-method-type="value"
                :default-value="advancedSearchForm.planner||''"
                @parentCallBack="getValueFromChild"
              />
            </el-form-item>
            <el-form-item :label="$t('Payment.businessStatus')" label-width="60px">
              <el-select
                v-model="advancedSearchForm.states"
                no="120"
                :placeholder="$t('common.tips.pleaseChoose')"
                multiple
                collapse-tags
                clearable
              >
                <el-option v-for="item in businessStatuses" :key="item.code" :label="isZh?item.chineseName:item.englishName" :value="item.code" />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('queryJob.IncoTerm')" label-width="60px">
              <cargo-advance-select
                no="121"
                cache
                multiple
                :select-type="selectTypeNames.basic_data_IncoTerm"
                callback-method-type="value"
                :callback-params="{key:'incoTermList'}"
                options-width="120px"
                :default-multiple-value="advancedSearchForm.incoTermList||[]"
                @parentCallBack="getValueFromChild"
              />
            </el-form-item>
            <el-form-item :label="$t('queryJob.masterBLFreightTerm')" label-width="85px" class="form-item-150">
              <cargo-advance-select
                no="122"
                cache
                :fields="['name']"
                multiple
                :select-type="selectTypeNames.basic_data_PaymentTerm"
                callback-method-type="value"
                :callback-params="{key:'paymentTermMBLs'}"
                options-width="180px"
                :default-multiple-value="advancedSearchForm.paymentTermMBLs||[]"
                @parentCallBack="getValueFromChild"
              />
            </el-form-item>
            <el-form-item :label="$t('Message.StateQuery')" label-width="85px" class="form-item-525">
              <div style="display: flex;">
                <el-input
                  no="123"
                  :value="stateQueryTxtContent"
                  size="mini"
                  readonly
                  :placeholder="$t('Message.DoubleClickToSelectState')"
                  @dblclick.native="toShowEdiStateQueryDialog()"
                />
                <el-button
                  v-show="!!stateQueryTxtContent"
                  size="mini"
                  @click="toClearEdiStateQuery()"
                >{{ $t('CargoMsg.Cargo_Clear') }}</el-button>
              </div>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_CustomJobType')" label-width="100px" class="form-item-200">
              <cargo-advance-select
                no="124"
                cache
                multiple
                :select-type="selectTypeNames.basic_data_CutomJobType"
                :data-filter-function="p => {
                  return p.type === 'SE'
                }"
                callback-method-type="value"
                :callback-params="{key:'customJobType'}"
                options-width="180px"
                :default-multiple-value="advancedSearchForm.customJobType || []"
                @parentCallBack="getValueFromChild"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_SendToExchangeTime')" label-width="100px">
              <el-date-picker
                v-model="rangeSendToExchangeDate"
                no="90"
                type="daterange"
                value-format="yyyy-MM-dd"
                style="width: 200px"
                :start-placeholder="$t('Tool.BeginDate')"
                :end-placeholder="$t('Project.EndtDate')"
              />
            </el-form-item>
          </div>
        </el-form>
        <div class="section grid-wrapper">
          <div v-if="oneKeyBookingEnable" style="display: flex;align-self: flex-end;padding: 8px" class="booking-state-statistic">
            <span>{{ $t('CargoMsg.Cargo_CurrentlyBooking') }}</span>
            <span style="cursor: pointer;text-decoration: underline;color: blue" @click="statisticClick(JOB_BOOKING_STATE_BOOKING.code)">{{ ediBookingStateStatisticsVo.bookingCount }}</span>
            <span style="margin-right: 10px">{{ $t('CargoMsg.Cargo_Pcst') }}</span>
            <span>{{ $t('CargoMsg.Cargo_SendSuccess2') }}</span>
            <span style="cursor: pointer;text-decoration: underline;color: blue" @click="statisticClick(JOB_BOOKING_STATE_BOOKING_SEND_SUCCESS.code)">{{ ediBookingStateStatisticsVo.bookingSendSuccessCount }}</span>
            <span style="margin-right: 10px">{{ $t('CargoMsg.Cargo_Pcst') }}</span>

            <span>{{ $t('CargoMsg.Cargo_SendFail') + ':' }}</span>
            <span style="cursor: pointer;text-decoration: underline;color: red" @click="statisticClick(JOB_BOOKING_STATE_BOOKING_SEND_FAIL.code)">{{ Number(ediBookingStateStatisticsVo.callEdiFailCount) + Number(ediBookingStateStatisticsVo.validFailCount) + Number(ediBookingStateStatisticsVo.templateMatchFailCount) }}</span>
            <span style="margin-right: 10px">{{ $t('CargoMsg.Cargo_Pcst') }}</span>

            <!--            <span>{{ $t('CargoMsg.Cargo_CallEdiFail') }}</span>-->
            <!--            <span style="cursor: pointer;text-decoration: underline;color: red" @click="statisticClick(JOB_BOOKING_STATE_BOOKING_SEND_FAIL.code)">{{ ediBookingStateStatisticsVo.callEdiFailCount }}</span>-->
            <!--            <span style="margin-right: 10px">{{ $t('CargoMsg.Cargo_Pcst') }}</span>-->
            <!--            <span>{{ $t('CargoMsg.Cargo_ValidFail') }}</span>-->
            <!--            <span style="cursor: pointer;text-decoration: underline;color: red" @click="statisticClick(JOB_BOOKING_STATE_VALID_FAIL.code)">{{ ediBookingStateStatisticsVo.validFailCount }}</span>-->
            <!--            <span style="margin-right: 10px">{{ $t('CargoMsg.Cargo_Pcst') }}</span>-->
            <!--            <span>{{ $t('CargoMsg.Cargo_TemplateMatchFail') }}</span>-->
            <!--            <span style="cursor: pointer;text-decoration: underline;color: red" @click="statisticClick(JOB_BOOKING_STATE_TEMPLATE_MATCH_FAIL.code)">{{ ediBookingStateStatisticsVo.templateMatchFailCount }}</span>-->
            <!--            <span>{{ $t('CargoMsg.Cargo_Pcst') }}</span>-->
          </div>
          <cargo-ag-grid
            config-module="140701"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            :show-selected-color="false"
            @gridReady="params=>{gridApi=params.api}"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination
            config-module="140701"
            :page.sync="searchConditions.pageNum"
            :limit.sync="searchConditions.pageSize"
            :total="total"
            @pagination="pageChanged"
          />
        </div>
      </div>
    </div>
    <!--  特殊元素, 隐藏, 用于简单上传触发系统文件选择弹窗  -->
    <input ref="importFile" type="file" accept=".pms" style="display:none;" @change="onImportFile">
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.cxt"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
    />
    <dialog-selector
      :visible.sync="selectorDialog.visible"
      :title="selectorDialog.title"
      :row-data="selectorDialog.rowData"
      @selected="getEDICallback"
    />
    <message-preview-dialog
      :visible.sync="messagePreviewDialog.visible"
      :params="messagePreviewDialog.params"
      @uploadSuccess="uploadSuccess"
    />
    <show-history-dialog :visible.sync="showHistoryDialog.visible" :params="showHistoryDialog.params" />
    <multi-seg-num-rules-dialog :visible.sync="multiSegNumRulesDialog.visible" @callback="multiSegNumRulesCallback" />
    <declarate-record-dialog :visible.sync="declarateRecordDialog.visible" :params="declarateRecordDialog.params" />
    <address-format-dialog :visible.sync="addressFormatDialog.visible" :show-grid="true" :params="addressFormatDialog.params" />
    <econtainer-history :visible.sync="econtainerHistoryDialog.visible" :params="econtainerHistoryDialog.params" />
    <error-log-dialog :visible.sync="errorLogDialog.visible" :error-log="errorLogDialog.errorLog" />
    <edi-scfi-prompt-dialog :visible.sync="ediScfiPromptDialog.visible" :params="ediScfiPromptDialog.params" />
    <go-freight-log-dialog :visible.sync="goFreightLogDialog.visible" :job-uuid="goFreightLogDialog.jobUuid" />
    <!-- api接口选择弹窗 -->
    <api-popup
      :visible.sync="apiPopup.visible"
      :title="apiPopup.title"
      :interface-type="apiPopup.interfaceType"
      :interface-array="apiPopup.interfaceArray"
      @selectedApi="apiPopup.callback"
    />
    <!-- EDI状态查询弹窗 -->
    <edi-state-query-dialog
      v-if="ediStateQueryDialog.isCreate"
      :visible.sync="ediStateQueryDialog.visible"
      :title="ediStateQueryDialog.title"
      :value="ediStateQueryDialog.value"
      @callback="ediStateQueryDialog.callback"
    />
    <!-- 提单补充信息 -->
    <cargo-doc-extend
      :visible.sync="cargoDocExtendDialog.visible"
      :title="cargoDocExtendDialog.title"
      :job-uuid="cargoDocExtendDialog.jobUuid"
      :carrier-id="cargoDocExtendDialog.carrierId"
    />
    <!-- 一键订舱 弹窗 -->
    <one-key-booking
      ref="oneKeyBooking"
      :visible.sync="oneKeyBooking.visible"
      @refresh="() => {
        if (expandSearchForm || paginationChanged) {
          fetchData()
        } else {
          queryBookingStateStatistics()
        }
      }"
    />
    <!-- 订舱失败弹窗-->
    <booking-fail-dialog
      :visible.sync="bookingFailDialog.visible"
      :select-data="bookingFailDialog.selectData"
      @refresh="() => {
        if (expandSearchForm || paginationChanged || searchConditions.jobNo) {
          fetchData()
        } else {
          queryBookingStateStatistics()
        }
      }"
    />
    <!-- 单条业务 配置规则验证弹窗-->
    <checking-window
      v-if="checkingWindow.visible"
      :visible.sync="checkingWindow.visible"
      :lob="checkingWindow.lob"
      :job="checkingWindow.job"
      :check-node="checkingWindow.checkNode"
      :call-back="checkingWindow.callBack"
    />
  </div>
</template>

<script>
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import URL from '@/api/urlTranslator'
import { DocumentManage } from '@/utils/commonUtil'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import dialogSelector from './components/edi/dialogSelector'
import messagePreviewDialog from './components/edi/messagePreviewDialog'
import showHistoryDialog from './components/edi/showHistoryDialog'
import multiSegNumRulesDialog from './components/edi/multiSegNumRulesDialog'
import declarateRecordDialog from './components/edi/declarateRecordDialog'
import econtainerHistory from './components/edi/econtainerHistory'
import addressFormatDialog from './components/edi/addressFormatDialog'
import errorLogDialog from './components/edi/errorLogDialog'
import ediScfiPromptDialog from './components/edi/ediScfiPromptDialog'
import goFreightLogDialog from './components/edi/goFreightLogDialog'
import ApiPopup from '@/views/cargo/v0/SeaExport/components/edi/apiPopup'
import * as ediApi from '@/api/seaExport/edi'
import * as jobApi from '@/api/seaExport/seaExportJob'
import * as trackingApi from '@/api/sysManage/baseConfig/businessManage'
import { getEDITemplate } from '@/api/sysManage/baseConfig/ediTemplate'
import { batchCheckCreditInfoFunc, checkCreditInfo } from '@/api/partner/creditInfo'
import { savePmsFile } from '@/api/seaExport/poItems'
import * as SEConst from '@/class/cargo/model/parameters/SeaExportConstants'
import * as SysConst from '@/class/cargo/model/parameters/SystemConstants'
import { cacheName, cache } from '@/utils/cacheManager'
import { getGridSelected } from '@/utils/agGrid'
import { ModelMap } from '@/class/cargo/model/parameters/ModelMap'
import { MBL, HBL } from '@/class/cargo/model/parameters/CargoDocConsts'
import { getUserInfo } from '@/utils/auth'
import ColumnUtils from '@/utils/ColumnUtils'
import store from '@/store'
import { Job } from '@/class/model/booking/Job'
import DateUtils from '@/utils/dateUtils'
import { ErrorTip } from '@/utils/class/ErrorTip'
import lodash from 'lodash'
import hblIcon from '@/assets/h_resize.png'
import mblIcon from '@/assets/m_resize.png'
import { exportExcel } from '@/utils/tableDataExportUtils'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import * as EdiType from '@/class/cargo/model/parameters/EdiType'
import EdiStateQueryDialog from '@/components/Cargo/Job/EdiStateQueryDialog'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import * as EdiSendType from '@/class/cargo/model/parameters/EdiSendType'
import CargoDocExtend from '@/views/cargo/v0/SeaExport/components/edi/cargoDocExtend.vue'
import * as ContainerLoadType from '@/class/cargo/model/parameters/ContainerLoadType'
import { CONTAINERS_EDI } from '@/class/cargo/model/parameters/EdiType'
import { BSWarningUtil } from '@/class/cargo/model/utils/BSWarningUtil'
import oneKeyBooking from '@/views/cargo/v0/SeaExport/components/edi/oneKeyBooking'
import BookingFailDialog from '@/views/cargo/v0/SeaExport/components/edi/bookingFailDialog'
import { getLatestBookingRecord, queryBookingStateStatistics } from '@/api/seaExport/edi'
import {
  JOB_BOOKING_STATE_BOOKING, JOB_BOOKING_STATE_BOOKING_SEND_FAIL, JOB_BOOKING_STATE_BOOKING_SEND_SUCCESS,
  JOB_BOOKING_STATE_FAIL_CODES, JOB_BOOKING_STATE_TEMPLATE_MATCH_FAIL, JOB_BOOKING_STATE_VALID_FAIL,
  BOOKING_SEND_METHODS, TRANSPORT_MODES, JOB_BOOKING_STATES, JOB_BOOKING_STATE_BOOKING_FAIL
} from '@/class/cargo/model/parameters/SystemConstants'
import $store from '@/store'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import CheckingWindow from '@/components/Cargo/Job/CheckingManager/CheckingWindow.vue'
import StrUtils from '@/utils/StrUtils'

export default {
  name: 'Edi',
  components: {
    CheckingWindow,
    cargoAdvanceSelect, cargoTemplateSelectorDialog, dialogSelector, messagePreviewDialog, showHistoryDialog, multiSegNumRulesDialog,
    declarateRecordDialog, addressFormatDialog, errorLogDialog, econtainerHistory, ediScfiPromptDialog, goFreightLogDialog, ApiPopup,
    EdiStateQueryDialog, CargoDocExtend, oneKeyBooking, BookingFailDialog
  },
  data() {
    return {
      BOOKING_SEND_METHODS, TRANSPORT_MODES,
      JOB_BOOKING_STATES, JOB_BOOKING_STATE_BOOKING,
      JOB_BOOKING_STATE_BOOKING_SEND_SUCCESS,
      JOB_BOOKING_STATE_BOOKING_SEND_FAIL,
      JOB_BOOKING_STATE_VALID_FAIL,
      JOB_BOOKING_STATE_TEMPLATE_MATCH_FAIL,
      isZh: this.$store.getters.language === 'zh',
      // 点击行时的行job对象
      selectedJob: {},
      configMap: new Map(),
      // 操作按钮enabled状态
      btnStatus: {
        bookingBtn: false,
        blBtn: false,
        vgmBtn: false,
        packingBtn: false,
        preShippingBtn: false,
        shippingBtn: false,
        clearBtn: false,
        xyE2OpenBtn: false,
        hasGoFreight: this.$checkPermission(['button_EDI_SendGoFreight'])
      },
      // 整箱类型
      containerLoadTypes: [...SEConst.CONTAINER_LOAD_TYPES],
      // 本地服务
      localServices: [SEConst.STUFFY_IS, SEConst.STUFFY_DD, SEConst.STUFFY_SD, SEConst.STUFFY_CT, SEConst.STUFFY_HT, SEConst.STUFFY_CIT],
      // 揽货类型
      solicitationTypes: [
        {
          'chineseName': this.$t('SeaExport.All'),
          'englishName': 'All',
          'code': ''
        },
        ...SysConst.CARGO_SOURCES
      ],
      businessStatuses: [...SysConst.JOB_STATES],
      selectTypeNames: TYPE_NAMES,
      loading: false,
      total: 0,
      searchConditions: {
        jobNo: '',
        pageNum: 1,
        pageSize: 50
      },
      // 原写法在点击叉号清除控件内容时不方便监听，以清除form对应的日期数据
      rangeDateETD: '',
      rangeDateETA: '',
      rangeSendToExchangeDate: '',
      rangeDateLoadingDate: '',
      rangeDateDateCreated: '',
      rangeDateCustomsDate: '',
      rangeDateActualUnBerthPlanDate: '',
      initAdvancedSearchForm: {
        warehouseNo: '',
        refNbr: '',
        containerNo: '',
        verificationNo: '',
        bookingNo: '',
        customerId: '',
        bookingAgent: '',
        destinationAgent: '',
        carrierId: '',
        poNo: '',
        loadingPortCode: '',
        transferPortCode: '',
        dischargingPortCodes: '',
        minETD: '',
        maxETD: '',
        customerRefNo: '',
        shipper: '',
        consignee: '',
        soNo: '',
        minETA: '',
        maxETA: '',
        scNo: '',
        vessel: '',
        voyageFlight: '',
        billingNo: '',
        minLoadingDate: '',
        maxLoadingDate: '',
        ams: '',
        vgm: '',
        contain: '',
        appoint: '',
        containerLoadTypes: '',
        stuffingTypes: '',
        cargoSource: '',
        minDateCreated: '',
        maxDateCreated: '',
        shutOut: '',
        cargoType: '',
        freightTerm: '',
        minCustomsDate: '',
        maxCustomsDate: '',
        minActualUnBerthPlanDate: '',
        maxActualUnBerthPlanDate: '',
        sales: '',
        op: '',
        csr: '',
        doc: '',
        planner: '',
        states: '',
        incoTermList: '',
        paymentTermMBLs: '',
        stateQuery: null,
        customJobType: ''
      },
      stateQueryTxtContent: '',
      advancedSearchForm: {},
      expandSearchForm: false,
      paginationChanged: false,
      tenantId: null,
      documentManage: new DocumentManage(),
      columnDefs: [
        {
          headerName: this.$t('Payment.consignationCompany'),
          field: 'customerId',
          colId: 'customerId',
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_0') : ''
          }
        }, {
          headerName: this.$t('queryJob.FLCLType'),
          field: 'containerLoadType',
          colId: 'containerLoadType'
        }, {
          headerName: this.$t('SeaExport.PortOfLoading'),
          field: 'loadingPortCode',
          colId: 'loadingPortCode',
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'auto_7')
          }
        }, {
          headerName: this.$t('SeaExport.PortOfDischarge'),
          field: 'dischargingPortCode',
          colId: 'dischargingPortCode',
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'auto_7')
          }
        }, {
          headerName: this.$t('queryJob.placeOfDelivery'),
          field: 'destinationPortCode',
          colId: 'destinationPortCode',
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'auto_7')
          }
        }, {
          headerName: this.$t('queryJob.dateOfDeparture'),
          field: 'etd',
          colId: 'etd',
          cellRenderer: params => {
            return DateUtils.customFormat(params.value, DateUtils.STANDARD_DATE)
          }
        }, {
          headerName: this.$t('SeaExport.DateOfArrival'),
          field: 'eta',
          colId: 'eta',
          cellRenderer: params => {
            return DateUtils.customFormat(params.value, DateUtils.STANDARD_DATE)
          }
        }, {
          headerName: this.$t('FileHistory.createdDate'),
          field: 'dateCreated',
          colId: 'dateCreated',
          cellRenderer: params => {
            return DateUtils.customFormat(params.value, DateUtils.STANDARD_DATE)
          }
        }, {
          headerName: this.$t('SeaExport.ShippingCompany'),
          field: 'carrierId',
          colId: 'carrierId',
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_5') : ''
          }
        }, {
          headerName: this.$t('Payment.mbl'),
          field: 'mbl',
          colId: 'mbl'
        }, {
          headerName: this.$t('Payment.destinationAgent'),
          field: 'destinationAgent',
          colId: 'destinationAgent',
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_2') : ''
          }
        }, {
          headerName: this.$t('SeaExport.Booking'),
          field: 'bookingEDI',
          colId: 'bookingEDI',
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.Bl'),
          field: 'blEDI',
          colId: 'blEDI',
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.DestinationAgent1'),
          field: 'agentEDI',
          colId: 'agentEDI',
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.SoNo'),
          field: 'soNo',
          colId: 'soNo'
        }, {
          headerName: this.$t('FileHistory.operation'),
          field: 'op',
          colId: 'op',
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'auto_op')
          }
        }, {
          headerName: this.$t('SeaExport.ShutOut'),
          field: 'shutOut',
          colId: 'shutOut',
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          }
        }, {
          headerName: this.$t('Payment.status'),
          field: 'jobState',
          colId: 'jobState',
          cellRenderer: (params) => {
            return ColumnUtils.getJobStateForBlock(params.data)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.getJobStateForBlock(params.data)
          }
        }, {
        //   headerName: this.$t('SeaExport.BookingStatus'),
        //   field: 'ediBookingSendStatus',
        //   colId: 'ediBookingSendStatus',
        //   cellRenderer: (params) => {
        //     return this.convertSendStatus(params)
        //   }
        // }, {
          headerName: this.$t('CargoMsg.Cargo_EdiBookingExportState'),
          field: 'ediBookingExportStatus',
          colId: 'ediBookingExportStatus',
          cellRenderer: (params) => {
            return ColumnUtils.bookingExportStatusLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.StateOfTheBillOfLading'),
          field: 'ediBillSendStatus',
          colId: 'ediBillSendStatus',
          cellRenderer: (params) => {
            return this.convertSendStatus(params)
          }
        }, {
          headerName: this.$t('SeaExport.InstallPackingListStatus'),
          field: 'ediInstallSendStatus',
          colId: 'ediInstallSendStatus',
          cellRenderer: (params) => {
            return this.convertSendStatus(params)
          }
        }, {
          headerName: this.$t('SeaExport.AdvanceManifestStatus'),
          field: 'ediShippingSendStatus',
          colId: 'ediShippingSendStatus',
          cellRenderer: (params) => {
            return this.convertSendStatus(params)
          }
        }, {
          headerName: this.$t('SeaExport.ManifestStatus'),
          field: 'ediManifestSendStatus',
          colId: 'ediManifestSendStatus',
          cellRenderer: (params) => {
            return this.convertSendStatus(params)
          }
        }, {
          headerName: this.$t('SeaExport.StateHisCase'),
          field: 'ediIssuedSendStatus',
          colId: 'ediIssuedSendStatus',
          cellRenderer: (params) => {
            return this.convertSendStatus(params)
          }
        }, {
          headerName: this.$t('SeaExport.StatusOfAnti_TerrorismManifest'),
          field: 'ediAfrSendStatus',
          colId: 'ediAfrSendStatus',
          hide: true,
          cellRenderer: (params) => {
            return this.convertSendStatus(params)
          }
        }, {
          headerName: this.$t('Payment.businessReferenceNumber'),
          field: 'customerRefNo',
          colId: 'customerRefNo',
          hide: true
        }, {
          headerName: this.$t('queryJob.containerDescription'),
          field: 'containerDesc',
          colId: 'containerDesc',
          cellRenderer: (params) => {
            return ColumnUtils.containerDescLabelFunc(params.value)
          },
          hide: true
        }, {
          headerName: 'TEU',
          field: 'teu',
          colId: 'teu',
          hide: true
        }, {
          headerName: this.$t('SeaExport.ScfiPrice'),
          field: 'scfiPrice',
          colId: 'scfiPrice',
          hide: true
        }, {
          headerName: this.$t('SeaExport.Vessel'),
          field: 'vessel',
          colId: 'vessel',
          hide: true
        }, {
          headerName: this.$t('SeaExport.Voyage'),
          field: 'voyageFlight',
          colId: 'voyageFlight',
          hide: true
        },
        { headerName: this.$t('SeaExport.BookingEdiSendingChannel'), field: 'bookingSendType', width: 250, colId: 'bookingSendType',
          valueFormatter: (params) => {
            return ColumnUtils.bookingEdiSendingChannelLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_BookingSendDate'), field: 'bookingSendDate', width: 250, colId: 'bookingSendDate',
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_BookingReceiptDate'), field: 'bookingReceiptDate', width: 250, colId: 'bookingReceiptDate',
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }, { headerName: this.$t('SeaExport.BL_EDI_SendChannel'), field: 'ladingBillSendType', width: 250, colId: 'ladingBillSendType',
          valueFormatter: (params) => {
            return ColumnUtils.bookingEdiSendingChannelLabelFunc(params.value)
          }
        },
        { headerName: this.$t('SeaExport.BL_EDI_SendTime'), field: 'ladingBillSendDate', width: 250, colId: 'ladingBillSendDate',
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }, { headerName: this.$t('SeaExport.CleanManifest_EDI_SendChannel'), field: 'ifcsumSendType', width: 250, colId: 'ifcsumSendType',
          valueFormatter: (params) => {
            return ColumnUtils.bookingEdiSendingChannelLabelFunc(params.value)
          }
        },
        { headerName: this.$t('SeaExport.CleanManifest_EDI_SendTime'), field: 'ifcsumSendDate', width: 250, colId: 'ifcsumSendDate',
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }, { headerName: this.$t('SeaExport.Way99_EDI_SendChannel'), field: 'installSendType', width: 250, colId: 'installSendType',
          valueFormatter: (params) => {
            return ColumnUtils.bookingEdiSendingChannelLabelFunc(params.value)
          }
        },
        { headerName: this.$t('SeaExport.Way99_EDI_SendTime'), field: 'installSendDate', width: 250, colId: 'installSendDate',
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }, { headerName: this.$t('SeaExport.AMS_EDI_SendTime'), field: 'amsSendDate', width: 250, colId: 'amsSendDate',
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }, { headerName: this.$t('SeaExport.AHR_EDI_SendTime'), field: 'afrSendDate', width: 250, colId: 'afrSendDate',
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }, { headerName: this.$t('SeaExport.PreShippingBill_EDI_SendChannel'), field: 'preconfigureShippingSendType', width: 250, colId: 'preconfigureShippingSendType',
          valueFormatter: (params) => {
            return ColumnUtils.bookingEdiSendingChannelLabelFunc(params.value)
          }
        },
        { headerName: this.$t('SeaExport.PreShippingBill_EDI_SendTime'), field: 'preconfigureShippingSendDate', width: 250, colId: 'preconfigureShippingSendDate',
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }, { headerName: this.$t('SeaExport.OverseaAgent_EDI_SendChannel'), field: 'overseaAgentSendType', width: 250, colId: 'overseaAgentSendType',
          valueFormatter: (params) => {
            return ColumnUtils.bookingEdiSendingChannelLabelFunc(params.value)
          }
        },
        { headerName: this.$t('SeaExport.OverseaAgent_EDI_SendTime'), field: 'overseaAgentSendDate', width: 250, colId: 'overseaAgentSendDate',
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_CustomJobType'), field: 'customJobType', width: 250, hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.customJobTypeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BookingState'),
          field: 'bookingState',
          colId: 'bookingState',
          width: 150,
          valueFormatter: (params) => {
            if ([JOB_BOOKING_STATE_BOOKING_SEND_FAIL.code, JOB_BOOKING_STATE_VALID_FAIL.code, JOB_BOOKING_STATE_TEMPLATE_MATCH_FAIL.code].includes(params.value)) {
              return ColumnUtils.jobBookingState(JOB_BOOKING_STATE_BOOKING_FAIL.code)
            }
            return ColumnUtils.jobBookingState(params.value)
          },
          onCellClicked: params => {
            if (JOB_BOOKING_STATE_FAIL_CODES.indexOf(params.data.bookingState) > -1) {
              this.bookingFailDialog.selectData = params.data
              const loading = getLoading()
              getLatestBookingRecord({ jobUuid: params.data.uuid }).then(res => {
                if (res.data) {
                  this.bookingFailDialog.selectData.bookingErrorCode = res.data.errorCode
                  this.bookingFailDialog.selectData.bookingErrorMsg = res.data.errorMsg
                }
                this.bookingFailDialog.visible = true
              }).finally(() => loading.close())
            }
          }
        },
        {
          headerName: this.$t('SeaExport.OrderChannels'),
          field: 'salesChannel',
          colId: 'salesChannel',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_BookingSendMethod'),
          field: 'bookingSendMethod',
          colId: 'bookingSendMethod',
          width: 50,
          valueFormatter: (params) => {
            return ColumnUtils.bookingSendMethodLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_BookingTransportMode'),
          field: 'bookingTransportMode',
          colId: 'bookingTransportMode',
          width: 50,
          valueFormatter: (params) => {
            return ColumnUtils.bookingTransportModeLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_OriginBookingState'),
          field: 'originBookingState',
          colId: 'originBookingState',
          width: 50
        }, { headerName: this.$t('CargoMsg.Cargo_SendToExchangeTime'), field: 'sendToExchangeDate', width: 250, colId: 'sendToExchangeDate',
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.ENS_EDI_SendTime'),
          field: 'ensSendDate',
          colId: 'ensSendDate',
          width: 250,
          hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }, {
          headerName: 'ENS' + this.$t('CargoMsg.Cargo_Status'),
          field: 'ensSendState',
          colId: 'ensSendState',
          hide: true,
          width: 100,
          valueFormatter: params => {
            return this.ensReceipt(params.data)
          }
        }
      ],
      bookingFailDialog: {
        visible: false,
        selectData: {}
      },
      rowData: [],
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        suppressRowClickSelection: true,
        treeData: true,
        groupDefaultExpanded: 2,
        getDataPath: data => {
          return data.path.split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('Payment.businessNumber'),
          field: 'jobNo',
          colId: 'jobNo',
          width: 240,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: false,
            checkbox: params => {
              const currentJob = params.data
              if (currentJob.hasOwnProperty('dataType') && Number(currentJob.dataType) !== 1 && Number(currentJob.dataType) !== 2) {
                return false
              }
              return true
            },
            innerRenderer: params => {
              const currentJob = params.data
              if (currentJob.hasOwnProperty('dataType') && Number(currentJob.dataType) !== 1 && Number(currentJob.dataType) !== 2) {
                const icon = Number(currentJob.dataType) === 5 ? hblIcon : mblIcon
                return `<span><img src="${icon}" height="16" width="16" style="vertical-align: sub;margin-right:3px;" />${params.value}</span>`
              }
              const methodPath = this.documentManage.getPath('toSearchTemplate')
              const pushMethodPath = this.documentManage.getPath('routerPush')
              return `<a href="javascript:void(0)" onclick="${pushMethodPath}('${params.value}')"
                        style="color:#0052cc;text-decoration:underline;">${params.value}</a>
                <i class="el-icon-search" onclick="${methodPath}('${params.data.jobNo}')" style="color:#46a6ff;cursor:pointer"/>`
            }
          }
        },
        // 单选（勾选框或者其他列，都会触发）
        onCellFocused: event => {
          const nodes = event.api.rowModel.rowsToDisplay
          const selectedNode = nodes[event.rowIndex] || null
          if (selectedNode) {
            this.rowClicked({ data: selectedNode.data })
          } else {
            this.rowClicked(null)
          }
        },
        getRowStyle: (params) => {
          const row = params.data
          const { colorSettings, colorType } = this
          if (colorType) {
            return JobUtils.financeColor(row)
          } else if (row.hasOwnProperty('dataType') && (Number(row.dataType) === 1 || Number(row.dataType) === 2)) {
            if (Object.prototype.hasOwnProperty.call(row, 'blocked') &&
              Object.prototype.hasOwnProperty.call(row, 'specialApproval') &&
              JobUtils.isBlockJob(row)) {
              return { 'background': colorSettings.find(item => item.colorKey === 'isBlocked').colorValue }
            } else {
              const jobState = String(row.jobState) || ''
              for (const stateColor of colorSettings) {
                if (jobState === stateColor.colorKey) {
                  return { 'background': stateColor.colorValue }
                }
              }
            }
          }
          return {}
        },
        context: {
          componentParent: this
        }
      },
      gridApi: null,
      // 组件全局变量 - 初始默认值
      initGlobalVar: {
        // 业务参数
        selectedJob: null,
        selectedJobKey: null,
        selectedJobs: null,
        selectedJobKeys: null,
        title: '',
        ediType: 0,
        editStatus: 0,
        ediTemplate: null,
        ediDatas: null,
        ediTemplateWin: { uuids: null, item: null },
        // 控制参数
        popMultiSegNumRulesType: 1, // 多段参数规则弹窗类型 1:订舱操作引用弹窗 2: 舱单操作引用弹窗
        sendRPA: false // 发送壹沓RAP
      },
      // 组件全局变量
      globalVar: {},
      // 模板选择弹窗
      templateSelectorDialog: {
        visible: false,
        cxt: new SeaExportJob(),
        category: 'JOBLIST',
        data: {
          JOB_UUID: [],
          LOB: 'SE'
        }
      },
      // edi弹窗选择器
      selectorDialog: {
        key: '',
        visible: false,
        title: this.$t('SeaExport.BookingEDI'),
        rowData: []
      },
      // 报文预览弹窗
      messagePreviewDialog: {
        visible: false,
        params: {}
      },
      // 舱单-多段号码规则配置-弹窗
      multiSegNumRulesDialog: {
        visible: false
      },
      // 反恐舱单-反恐地址格式化-弹窗
      addressFormatDialog: {
        visible: false,
        params: { cargoDocs: [] }
      },
      // SCFI申报-申报记录-弹窗
      declarateRecordDialog: {
        visible: false,
        params: {}
      },
      // 查看记录弹窗
      showHistoryDialog: {
        visible: false,
        params: {}
      },
      // 电子箱单发送历史记录弹窗
      econtainerHistoryDialog: {
        visible: false,
        params: {}
      },
      // 错误日志显示弹窗
      errorLogDialog: {
        visible: false,
        errorLog: ''
      },
      // scfi申报校验对话框
      ediScfiPromptDialog: {
        visible: false,
        params: {}
      },
      // GO FREIGHT
      goFreightLogDialog: {
        visible: false,
        jobUuid: ''
      },
      // api弹框
      apiPopup: {
        visible: false,
        title: '',
        interfaceType: 1,
        interfaceArray: '',
        callback: () => {}
      },
      // 一键订舱 弹框
      oneKeyBooking: {
        visible: false
      },
      ediStatusName: '',
      ediStateQueryDialog: { // EDI状态查询弹窗
        isCreate: false,
        visible: false,
        title: '',
        value: {},
        callback: null
      },
      cargoDocExtendDialog: { // 提单补充信息弹窗
        visible: false,
        title: '',
        jobUuid: '',
        carrierId: 0,
        callback: null
      },
      isHZ: false, // 宏真对接民生使用
      ediBookingStateStatisticsVo: {},
      oneKeyBookingEnable: false, // 是否开启【一键订舱】
      checkingWindow: {
        visible: false,
        job: null,
        lob: '',
        checkNode: 0,
        callBack: null
      }
    }
  },
  computed: {
    currentOfficeId() {
      return Number(this.$store.getters.currentOfficeId)
    },
    url() {
      return URL
    },
    expandClass() {
      return { 'el-icon-d-arrow-left': this.expandSearchForm, 'el-icon-d-arrow-right': !this.expandSearchForm, 'el-icon--right': true }
    },
    colorType() {
      return Number(this.$store.state.settings.colorType) === 1
    },
    colorSettings() {
      return this.$store.state.settings.colorSettings
    }
  },
  watch: {
    async currentOfficeId() {
      await cache.load(cacheName.CONFIG)
      this.configMap = cache.config
    },
    // 监听日期控件清空时，Form日期也清空
    rangeDateETD(newVal) {
      this.rangeDateHandle('ETD', newVal)
    },
    rangeDateETA(newVal) {
      this.rangeDateHandle('ETA', newVal)
    },
    rangeSendToExchangeDate(newVal) {
      this.rangeDateHandle('sendToExchangeDate', newVal)
    },
    rangeDateLoadingDate(newVal) {
      this.rangeDateHandle('loadingDate', newVal)
    },
    rangeDateDateCreated(newVal) {
      this.rangeDateHandle('dateCreated', newVal)
    },
    rangeDateCustomsDate(newVal) {
      this.rangeDateHandle('customsDate', newVal)
    },
    rangeDateActualUnBerthPlanDate(newVal) {
      this.rangeDateHandle('actualUnBerthPlanDate', newVal)
    },
    colorSettings: {
      handler() {
        this.gridOptions.api.redrawRows()
      },
      deep: true
    }
  },
  created() {
    this.tenantId = getUserInfo().tenantId
    this.isAdmin = store.getters && store.getters.isAdmin
    this.isHZ = String(cache.config.get('ToExoSystem')) === 'HZ'
    this.oneKeyBookingEnable = Number(cache.config.get('OneKeyBookingEnable')) === 1
    this.queryBookingStateStatistics()
  },
  beforeMount() {
    const context = this
    this.documentManage.set('toSearchTemplate', function(value) {
      context.toSearchTemplate(value)
    })
    this.documentManage.set('routerPush', function(value) {
      context.routerPush(value)
    })
  },
  async mounted() {
    this.advancedSearchForm = { ...this.initAdvancedSearchForm }
    await cache.load(cacheName.CONFIG)
    this.configMap = cache.config
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    routerPush(jobNo) {
      if (!this.$checkPermission(['module_fmBookingNew'])) {
        this.$message.warning(this.$t('SeaExport.ImNotHavePermissionDetails'))
        return
      }
      this.$router.push({
        path: '/SeaExport/BookingNew',
        query: { jobNo }
      })
    },
    // 为Form的对应日期属性赋值
    rangeDateHandle(rangeDateProp, arr) {
      const dateProp = rangeDateProp.charAt(0).toUpperCase() + rangeDateProp.slice(1)
      if (arr) {
        this.advancedSearchForm['min' + dateProp] = arr[0]
        this.advancedSearchForm['max' + dateProp] = arr[1]
      } else {
        this.advancedSearchForm['min' + dateProp] = ''
        this.advancedSearchForm['max' + dateProp] = ''
      }
    },
    // 获取选中行 dataType 区分拆并单数据 业务数据，1 主票 2 小票 3 MBL 4 MBL2 5 HBL2
    readSelectedRows() {
      const allRows = getGridSelected(this.gridOptions)
      const rows = []
      for (const row of allRows) {
        if (row.hasOwnProperty('dataType') && (Number(row.dataType) === 1 || Number(row.dataType) === 2)) {
          rows.push(row)
        }
      }
      if (rows.length === 0) {
        throw new ErrorTip(this.$t('common.tips.hasOneAtleast'))
      }
      return rows
    },
    getValueFromChild(obj) {
      this.advancedSearchForm[obj.key] = obj.value
    },
    getValueSearchFromChild(obj) {
      this.advancedSearchForm[obj.key] = obj.value
    },
    statisticClick(bookingState) {
      this.expandSearchForm = true
      this.searchConditions = {
        pageNum: 1,
        pageSize: 50
      }
      this.resetSearchForm()
      if (bookingState === JOB_BOOKING_STATE_BOOKING_SEND_FAIL.code) {
        this.advancedSearchForm.bookingStates = [JOB_BOOKING_STATE_BOOKING_SEND_FAIL.code, JOB_BOOKING_STATE_VALID_FAIL.code, JOB_BOOKING_STATE_TEMPLATE_MATCH_FAIL.code]
        this.advancedSearchForm.newBookingStates = [JOB_BOOKING_STATE_BOOKING_FAIL.code]
      } else {
        this.advancedSearchForm.bookingStates = [bookingState]
        this.advancedSearchForm.newBookingStates = [bookingState]
      }
      const start = new Date()
      start.setMonth(start.getMonth() - 2)
      this.rangeDateDateCreated = [DateUtils.formatStandardDate(start), DateUtils.formatStandardDate(new Date())]
      this.rangeDateHandle('dateCreated', this.rangeDateDateCreated)
      this.fetchData()
    },
    queryBookingStateStatistics() {
      if (this.oneKeyBookingEnable) {
        queryBookingStateStatistics({ opOffice: this.currentOfficeId }).then(res => {
          this.ediBookingStateStatisticsVo = res.data
        })
      }
    },
    fetchData() {
      let params
      let queryMethod
      if (this.expandSearchForm || this.paginationChanged) {
        this.paginationChanged = false
        // 范围日期值处理 （已改为直接监听控件变化来绑定日期）
        params = { ...this.searchConditions, ...this.advancedSearchForm, opOffice: this.currentOfficeId }
        params.jobNo = ''
        queryMethod = ediApi.findEDI
      } else {
        const jobNo = this.searchConditions.jobNo
        if (!jobNo || jobNo.trim() === '') {
          this.$message.warning(this.$t('Message.PleaseInputBussinessNo'))
          return
        }
        this.searchConditions.jobNo = jobNo.trim()
        params = { ...this.searchConditions, opOffice: this.currentOfficeId }
        queryMethod = ediApi.findEDIByJobNo
      }

      if (params) {
        if (params.newBookingStates && params.newBookingStates.includes(JOB_BOOKING_STATE_BOOKING_FAIL.code)) {
          params.bookingStates = [...params.newBookingStates, JOB_BOOKING_STATE_BOOKING_SEND_FAIL.code, JOB_BOOKING_STATE_VALID_FAIL.code, JOB_BOOKING_STATE_TEMPLATE_MATCH_FAIL.code]
        } else {
          params.bookingStates = params.newBookingStates
        }
      }
      this.loading = getLoading4Cxt(this)
      queryMethod(params).then((res) => {
        this.rowData = res.data.list
        this.searchConditions.pageNum = res.data.pageNum
        this.total = Number(res.data.total)
        this.gridApi.clearFocusedCell()
      }).finally(() => {
        this.loading.close()
      })
      this.queryBookingStateStatistics()
    },
    resetSearchForm() {
      this.rangeDateETD = ''
      this.rangeDateETA = ''
      this.rangeSendToExchangeDate = ''
      this.rangeDateLoadingDate = ''
      this.rangeDateDateCreated = ''
      this.rangeDateCustomsDate = ''
      this.rangeDateActualUnBerthPlanDate = ''
      this.advancedSearchForm = { ...this.initAdvancedSearchForm }
      this.stateQueryTxtContent = ''
    },
    rowClicked(event) {
      // 选中行为主票的MBL单时,event置空
      if (event) {
        const data = event.data
        if (data && Number(data.dataType) !== 1 && Number(data.dataType) !== 2) {
          event = null
        }
      }
      if (!event) {
        this.btnStatus.xyE2OpenBtn = false
        this.btnStatus.bookingBtn = false
        this.btnStatus.blBtn = false
        this.btnStatus.vgmBtn = false
        this.btnStatus.packingBtn = false
        this.btnStatus.preShippingBtn = false
        this.btnStatus.shippingBtn = false
        this.btnStatus.clearBtn = false
        return
      }
      const data = event.data
      this.btnStatus.blBtn = true
      this.btnStatus.vgmBtn = data.vgm
      this.btnStatus.preShippingBtn = true
      this.btnStatus.shippingBtn = true
      this.btnStatus.clearBtn = true
      this.btnStatus.xyE2OpenBtn = true
      if (data.masterFlag) {
        this.btnStatus.bookingBtn = true
        this.btnStatus.packingBtn = false
      } else {
        this.btnStatus.bookingBtn = data.containerLoadType !== 'LCL'
        this.btnStatus.packingBtn = data.containerLoadType !== 'LCL'
      }
      // 点击行时多选框自动勾选该行并清除其他行的勾选，此处记录点击行时选择的job对象，用以和点击行后，继续勾选其他行的多选框的job进行区分
      this.selectedJob = event.data
    },
    // 展示表格首列【业务编号】单元格中搜索图标点击触发事件
    toSearchTemplate(value) {
      const self = this
      if (!value) {
        self.$message.warning(`没有找到${value}对应的打印模板`)
      } else {
        this.templateSelectorDialog.category = 'JOB_DETAIL_OP'
        this.templateSelectorDialog.data = { 'JOB_UUID': value }
        this.templateSelectorDialog.visible = true
      }
    },
    // 选择下拉菜单触发 - 分配事件处理
    async onMenuSelect(index, indexPath) {
      // 初始化公共变量
      this.globalVar = this.initGlobalVar
      // 初始化勾选job & job相关构造变量
      if (!['query', 'reset'].includes(indexPath[0])) {
        this.common().getSelectedJobs()
      }
      // 路由操作选项
      let allowBooking
      switch (indexPath[0]) {
        case 'query': this.fetchData()
          break
        case 'reset': this.resetSearchForm()
          break
        case 'booking': // 订舱
          allowBooking = await BSWarningUtil.checkEDIExpire()
          if (!allowBooking) {
            return
          }
          // CARGO-46703 对EDI的货物明细取值进行校验
          await this.toBookingPre(indexPath.join('.'))
          break
        case 'bl': // 提单
          // CARGO-46703 edi提单添加验证节点校验
          await this.toBlPre(indexPath.join('.'))
          break
        case 'vgm': // VGM
          this.toVgm(indexPath.join('.'))
          break
        case 'sham': // 海外代理预报
          this.toSham(indexPath.join('.'))
          break
        case 'packing': // 安装箱
          this.packingHandler()
          break
        case 'preShipping': // 预配舱单
          this.toPreShipping(indexPath.join('.'))
          break
        case 'shipping': // 舱单
          this.shippingHandler().handle()
          break
        case 'afr': // 反恐舱单
          this.toAFR(indexPath.join('.'))
          break
        case 'clear': // 清洁舱单
          this.clearHandler()
          break
        case 'suitcase': // 提箱
          this.suitcaseHandler().handle()
          break
        case 'containerInfo': // 装箱信息
          this.toContainerInfo()
          break
        case 'freight': // GO FREIGHT
          this.toFreight(indexPath.join('.'))
          break
        case 'scfi': // SCFI申报
          this.toScfi(indexPath.join('.'))
          break
        case 'export': // 导出excel
          this.exportHandler()
          break
        case 'history': // 查看历史
          this.historyHandler()
          break
        case 'electronicPacking': // 99路电子装箱单
          this.toElectronicPacking(indexPath.join('.'))
          break
        case 'E2Open': // 对接星亚E2Open系统
          this.toE2Open(indexPath.join('.'))
          break
        default:
          console.error(this.$t('SeaExport.ActionOptionsNotCaptured'))
      }
    },
    // CARGO-46703 对EDI的货物明细取值进行校验
    async toBookingPre(index) {
      // 定义EDI相关的路径数组
      const ediPaths = ['booking.origin.API', 'booking.origin.FTP', 'booking.correct.API', 'booking.correct.FTP', 'booking.origin.RPA1']
      // 只处理发送edi 其他走原本的逻辑
      if (ediPaths.includes(index)) {
        // 判断是否开启验证规则
        const useCheckRule = Number(this.configMap.get('useCheckRule')) === 1
        // 查询是否存在节点
        const checkNodeFlag = await JobUtils.hasCheckRuleCondition(true, CheckRuleConstants.NODE_BOOKING_EDI_UPLOAD.code, this.$store.getters.currentOfficeId)
        if (useCheckRule && checkNodeFlag) {
          this.checkingWindow.visible = true
          // 手动赋值
          const job = this.rowData[0]
          job.lob = 'SE'
          this.checkingWindow.lob = job.lob
          this.checkingWindow.job = job
          this.checkingWindow.checkNode = CheckRuleConstants.NODE_BOOKING_EDI_UPLOAD.code
          this.checkingWindow.callBack = () => { this.toBooking(index) }
        } else {
          this.toBooking(index)
        }
      } else {
        this.toBooking(index)
      }
    },
    // >>> === 操作选项路由
    // 【订舱】下拉菜单选择触发事件路由
    toBooking(value) {
      this.globalVar.sendRPA = false
      this.selectorDialog.key = 'booking'
      switch (value) {
        case 'booking.origin.API':
          this.ediStatusName = this.$t('SeaExport.OriginalBooking')
          this.bookingEDIApi('9')
          break
        case 'booking.origin.FTP':
          this.ediStatusName = this.$t('SeaExport.OriginalBooking')
          this.bookingHandler().btnBookingEdiNewClickHandler()
          break
        case 'booking.correct.API':
          this.ediStatusName = this.$t('SeaExport.CorrectBooking')
          this.bookingEDIApi('5')
          break
        case 'booking.correct.FTP':
          this.ediStatusName = this.$t('SeaExport.CorrectBooking')
          this.bookingHandler().btnBookingEdiEditClickHandler()
          break
        case 'booking.import':
          this.bookingHandler().btnBookingEdiReceiptClickHandler()
          break
        case 'booking.oneKeyBooking':
          this.showOneKeyBookingDialog()
          break
        case 'booking.origin.RPA1':
          // 正在订舱
          if (this.globalVar.selectedJobs) {
            for (const item of this.globalVar.selectedJobs) {
              if (item && (item.bookingState === JOB_BOOKING_STATE_BOOKING.code || item.ediBookingSendStatus)) {
                this.$message.warning(this.$t('CargoMsg.Cargo_CheckCanSendEDI'))
                return
              }
            }
          }
          this.globalVar.sendRPA = true
          this.ediStatusName = this.$t('SeaExport.OriginalBooking')
          this.bookingHandler().btnBookingEdiNewClickHandler()
          break
        default:
          this.ediStatusName = this.$t('SeaExport.OriginalBooking')
          this.bookingHandler().btnBookingEdiNewClickHandler()
      }
    },
    /**
     * api接口集合 原始  state 9：新增  5：修改 1：取消
     */
    async bookingEDIApi(state) {
      await this.common().selectedJobItemClick()
      this.apiPopup.title = '订舱API'
      this.apiPopup.interfaceType = 1
      if (this.isHZ && state === '9') {
        this.apiPopup.interfaceArray = '4'
      } else {
        this.apiPopup.interfaceArray = this.configMap.get('BookingEDIApiOpen')
      }
      if (state === '9') {
        this.apiPopup.callback = this.getApi
      } else if (state === '5') {
        this.apiPopup.callback = this.getApiUpdate
      } else {
        this.apiPopup.callback = () => {}
      }
      this.apiPopup.visible = true
    },
    async showOneKeyBookingDialog() {
      const params = {
        opOffice: $store.getters.currentOfficeId,
        excludeJobUuids: []
      }
      await this.$refs.oneKeyBooking.loadData(params)
      if (this.$refs.oneKeyBooking.total > 0) {
        this.oneKeyBooking.visible = true
      } else {
        this.$message.warning(this.$t('CargoMsg.Cargo_CanNotBooking'))
      }
    },
    /**
     * API选择接口
     */
    async getApi(data) {
      const inteface = data.id
      if (inteface === '1') {
        await this.common().selectedJobItemClick()
        const params = {
          jobUuid: this.globalVar.selectedJob.uuid,
          editStatus: '1'
        }
        ediApi.getSinOTransApi(params).then(result => {
          this.commonCallback().onApiSuccess(result)
        })
      } else if (inteface === '2') {
        this.ningBoEportAPI('9', 'IFTMBF')
      } else if (inteface === '3') {
        this.jiLianStarAPI('9', EdiType.BOOKING_EDI_TYPE.code)
      } else if (inteface === '4') {
        this.getMingShenBookingAPI(EdiType.BOOKING_EDI_TYPE.code)
      }
    },
    /**
     * API更新接口接口
     */
    async getApiUpdate(data) {
      const inteface = data.id
      if (inteface === '1') {
        await this.common().selectedJobItemClick()
        const params = {
          jobUuid: this.globalVar.selectedJob.uuid,
          editStatus: '2'
        }
        ediApi.getSinOTransApi(params).then(result => {
          this.commonCallback().onApiSuccess(result)
        })
      } else if (inteface === '2') {
        this.ningBoEportAPI('5', 'IFTMBF')
      } else if (inteface === '3') {
        this.jiLianStarAPI('5', EdiType.BOOKING_EDI_TYPE.code)
      }
    },
    // CARGO-46703 对EDI的货物明细取值进行校验
    async toBlPre(index) {
      // 定义EDI相关的路径数组
      const ediPaths = ['bl.origin.API', 'bl.origin.FTP', 'bl.correct.API', 'bl.correct.FTP']
      // 只处理发送edi 其他走原本的逻辑
      if (ediPaths.includes(index)) {
        // 判断是否开启验证规则
        const useCheckRule = Number(this.configMap.get('useCheckRule')) === 1
        // 查询是否存在节点
        const checkNodeFlag = await JobUtils.hasCheckRuleCondition(true, CheckRuleConstants.NODE_LADING_BILL_EDI_UPLOAD.code, this.$store.getters.currentOfficeId)
        if (useCheckRule && checkNodeFlag) {
          this.checkingWindow.visible = true
          // 手动赋值
          const job = this.rowData[0]
          job.lob = 'SE'
          this.checkingWindow.lob = job.lob
          this.checkingWindow.job = job
          this.checkingWindow.checkNode = CheckRuleConstants.NODE_LADING_BILL_EDI_UPLOAD.code
          this.checkingWindow.callBack = () => { this.toBl(index) }
        } else {
          this.toBl(index)
        }
      } else {
        this.toBl(index)
      }
    },
    // 【提单】下拉菜单选择触发事件路由
    toBl(value) {
      this.selectorDialog.key = 'bl'
      switch (value) {
        case 'bl.origin.API':
          this.ediStatusName = this.$t('SeaExport.OriginalBillOfLading')
          this.billEDIApi('9')
          break
        case 'bl.origin.FTP':
          this.ediStatusName = this.$t('SeaExport.OriginalBillOfLading')
          this.blHandler().btnBlEdiNewClickHandler()
          break
        case 'bl.correct.API':
          this.ediStatusName = this.$t('SeaExport.CorrectionOfBillOfLading')
          this.billEDIApi('5')
          break
        case 'bl.correct.FTP':
          this.ediStatusName = this.$t('SeaExport.CorrectionOfBillOfLading')
          this.blHandler().btnBlEdiEditClickHandler()
          break
        case 'bl.CargoDocExtend':
          // if (this.selectedJob.containerLoadType === ContainerLoadType.LCL_CARGO_TYPE.code) {
          //   this.$message.warning(this.$t('SeaExport.PlsSelectUnLCL'))
          // } else {
          this.ediStatusName = this.$t('SeaExport.EdiEuBolInfo')
          this.cargoDocExtendDialog.title = this.$t('SeaExport.EdiEuBolInfo')
          this.cargoDocExtendDialog.jobUuid = this.globalVar.selectedJob.uuid
          this.cargoDocExtendDialog.carrierId = this.globalVar.selectedJob.carrierId
          this.cargoDocExtendDialog.visible = true
          // }
          break
        default:
          this.ediStatusName = this.$t('SeaExport.OriginalBillOfLading')
          this.blHandler().btnBlEdiNewClickHandler()
      }
    },
    /**
     * api接口集合 原始  state 9：新增  5：修改 1：取消
     */
    async billEDIApi(state) {
      await this.common().selectedJobItemClick()
      this.apiPopup.title = '提单API'
      this.apiPopup.interfaceType = 4
      this.apiPopup.interfaceArray = this.configMap.get('BillEDIApiOpen')
      if (state === '9') {
        this.apiPopup.callback = this.getBillApi
      } else if (state === '5') {
        this.apiPopup.callback = this.getBillApiUpdate
      } else {
        this.apiPopup.callback = () => {}
      }
      this.apiPopup.visible = true
    },
    /**
     * API选择接口
     */
    async getBillApi(data) {
      const inteface = data.id
      if (inteface === '1') {
        this.ningBoEportAPI('9', 'IFTMIN')
      }
    },
    /**
     * API更新接口接口
     */
    async getBillApiUpdate(data) {
      const inteface = data.id
      if (inteface === '1') {
        this.ningBoEportAPI('5', 'IFTMIN')
      }
    },
    // 【VGM】下拉菜单选择触发事件路由
    toVgm(value) {
      this.selectorDialog.key = 'vgm'
      this.globalVar.ediType = 11
      switch (value) {
        case 'vgm.origin':
          this.globalVar.editStatus = 9
          this.globalVar.title = this.$t('SeaExport.VGMRaw')
          this.ediStatusName = this.$t('SeaExport.VGMRaw')
          break
        case 'vgm.correct':
          this.globalVar.editStatus = 4
          this.globalVar.title = this.$t('SeaExport.VGMCorrection')
          this.ediStatusName = this.$t('SeaExport.VGMCorrection')
          break
      }
      this.vgmHandler()
    },
    // 【海外代理预报】下拉菜单选择触发事件路由
    toSham(value) {
      switch (value) {
        case 'sham.overseaAgent':
          this.ediStatusName = this.$t('SeaExport.OverseasAgeFore')
          this.shamHandler().sendOverseasAgentsEvent()
          break
        case 'sham.cargoWise':
          this.ediStatusName = 'CargoWise'
          this.shamHandler().sendCargoWiseEvent()
          break
        case 'sham.jinYi.origin':
          this.ediStatusName = this.$t('SeaExport.Original') + this.$t('SeaExport.JingyiSystemForecast')
          this.shamHandler().sendKinNitEvent('A')
          break
        case 'sham.jinYi.correct':
          this.ediStatusName = this.$t('SeaExport.Original') + this.$t('SeaExport.JingyiSystemForecast')
          this.shamHandler().sendKinNitEvent('U')
          break
        case 'sham.jinYi.delete':
          this.ediStatusName = this.$t('SeaExport.Delete') + this.$t('SeaExport.JingyiSystemForecast')
          this.shamHandler().sendKinNitEvent('D')
          break
        case 'sham.jcl.origin':
          this.globalVar.title = this.$t('SeaExport.Original') + this.$t('SeaExport.JclForecast')
          this.ediStatusName = this.$t('SeaExport.Original')
          this.jclHandler(9)
          break
        case 'sham.jcl.correct':
          this.globalVar.title = this.$t('SeaExport.Correct') + this.$t('SeaExport.JclForecast')
          this.ediStatusName = this.$t('SeaExport.Correct')
          this.jclHandler(5)
          break
        case 'sham.jcl.delete':
          this.globalVar.title = this.$t('CargoMsg.Cargo_Delete') + this.$t('SeaExport.JclForecast')
          this.ediStatusName = this.$t('CargoMsg.Cargo_Delete')
          this.jclHandler(1)
          break
      }
    },
    // 预配舱单操作处理器
    jclHandler(state) {
      this.globalVar.editStatus = state
      this.globalVar.ediType = EdiType.JCL_EDI_TYPE.code
      this.globalVar.ediTemplate = {}
      this.globalVar.ediTemplate.defaultFileType = '.xml'
      if (this.common().checkConfig('useEDITemplate', '1')) {
        this.common().showEDITemplateWin(this.globalVar.selectedJobKeys)
      } else {
        const params = { jobUuids: this.globalVar.selectedJobKeys, editStatus: this.globalVar.editStatus, ediType: this.globalVar.ediType, templateId: this.globalVar.ediTemplate.uuid }
        this.loading = getLoading4Cxt(this)
        ediApi.getEDI(params).then(response => {
          this.commonCallback().onExportEDISuccess(response)
        }).catch(err => {
          this.commonCallback().onExportEDIFail(err)
        }).finally(() => {
          this.loading.close()
        })
      }
    },
    // 【预配舱单】下拉菜单选择触发事件路由
    toPreShipping(value) {
      this.selectorDialog.key = 'preShipping'
      switch (value) {
        case 'preShipping.origin.API':
          this.ediStatusName = this.$t('SeaExport.OriginalPreAllocatedManifest')
          this.preShippingApi('9')
          break
        case 'preShipping.origin.FTP':
          this.ediStatusName = this.$t('SeaExport.OriginalPreAllocatedManifest')
          this.preShippingHandler().btnPreShippingEdiClickHandler()
          break
        case 'preShipping.correct.API':
          this.ediStatusName = this.$t('SeaExport.CorrectionOfPreAllocationManifest')
          this.preShippingApi('5')
          break
        case 'preShipping.correct.FTP':
          this.ediStatusName = this.$t('SeaExport.CorrectionOfPreAllocationManifest')
          this.preShippingHandler().btnPreShippingEdiUpdateClickHandler()
          break
        case 'preShipping.delete.API':
          this.ediStatusName = this.$t('SeaExport.DeletePreConfiguredManifest')
          this.preShippingApi('1')
          break
        case 'preShipping.delete.FTP':
          this.ediStatusName = this.$t('SeaExport.DeletePreConfiguredManifest')
          this.preShippingHandler().btnPreShippingEdiDeleteClickHandler()
          break
        default:
          this.ediStatusName = this.$t('SeaExport.OriginalPreAllocatedManifest')
          this.preShippingHandler().btnPreShippingEdiClickHandler()
      }
    },
    /**
     * api接口集合 原始  state 9：新增  5：修改 1：删除
     */
    async preShippingApi(state) {
      await this.common().selectedJobItemClick()
      this.apiPopup.title = this.$t('SeaExport.PreConfiguredManifestAPI')
      this.apiPopup.interfaceType = 2
      if (this.isHZ && state === '9') {
        this.apiPopup.interfaceArray = '5'
      } else {
        this.apiPopup.interfaceArray = this.configMap.get('PreplanEDIApiOpen')
      }
      if (state === '9') {
        this.apiPopup.callback = this.getPreShippingApi
      } else if (state === '5') {
        this.apiPopup.callback = this.getPreShippingApiUpdate
      } else {
        this.apiPopup.callback = () => {}
      }
      this.apiPopup.visible = true
    },
    /**
     * API选择接口
     */
    async getPreShippingApi(data) {
      const id = data.id
      if (id === '2') {
        this.jiLianStarAPI('9', EdiType.SHIPPING_EDI_TYPE.code)
      } else if (id === '5') {
        this.getMingShenBookingAPI(EdiType.SHIPPING_EDI_TYPE.code)
      }
    },
    /**
     * API更新接口接口
     */
    async getPreShippingApiUpdate(data) {
      const id = data.id
      if (id === '2') {
        this.jiLianStarAPI('5', EdiType.SHIPPING_EDI_TYPE.code)
      }
    },
    /**
     * API更新接口接口
     */
    getContainerInfo(data) {
      const id = data.id
      if (id === '1') {
        this.getMingShenBookingAPI(EdiType.CONTAINERS_EDI.code)
      }
    },
    // 【反恐舱单】下拉菜单选择触发事件路由
    async toAFR(value) {
      await this.common().selectedJobItemCheck()
      switch (value) {
        case 'afr.origin_ahr' + '.API':
          this.globalVar.title = this.$t('SeaExport.OriginalAHR')
          this.globalVar.editStatus = 9
          this.afrHandler().btnAFRClickAPIHandler()
          break
        case 'afr.origin_ahr' + '.FTP':
          this.globalVar.title = this.$t('SeaExport.OriginalAHR')
          this.globalVar.editStatus = 9
          this.afrHandler().btnAFREdiClickHandler()
          break
        case 'afr.add_chr' + '.API':
          this.globalVar.title = this.$t('SeaExport.AddChr')
          this.globalVar.editStatus = 2
          this.afrHandler().btnAFRClickAPIHandler()
          break
        case 'afr.add_chr' + '.FTP':
          this.globalVar.title = this.$t('SeaExport.AddChr')
          this.globalVar.editStatus = 2
          this.afrHandler().btnAFREdiClickHandler()
          break
        case 'afr.update_afr' + '.API':
          this.globalVar.title = this.$t('SeaExport.Correct')
          this.globalVar.editStatus = 5
          this.afrHandler().btnAFRClickAPIHandler()
          break
        case 'afr.update_afr' + '.FTP':
          this.globalVar.title = this.$t('SeaExport.Correct')
          this.globalVar.editStatus = 5
          this.afrHandler().btnAFREdiClickHandler()
          break
        case 'afr.format_address':
          this.afrHandler().btnAFRAddressClickHandler()
          break
      }
    },
    // 【GO FREIGHT】下拉菜单选择触发事件路由
    toFreight(value) {
      const rows = this.gridApi.getSelectedRows().filter(p => Number(p.dataType) === 1 || Number(p.dataType) === 2)
      switch (value) {
        case 'freight.send_freight': // GO FREIGHT/发送至GO FREIGHT
          this.sendgoFreightEvent(rows)
          break
        case 'freight.look_freight': // GO FREIGHT/查看发送日志
          this.querySendLog(rows)
          break
      }
    },
    // 发送goFreight
    async sendgoFreightEvent(rows) {
      if (rows.length === 0) {
        this.$message.warning(this.$t('SeaExport.PleaseSelect2'))
      } else if (rows.length > 1) {
        this.$message.warning(this.$t('SeaExport.BatchNotSupportedPleaseAgain'))
      } else {
        const loading = getLoading4Cxt(this)
        try {
          let res = await ediApi.checkIsSended({ key: rows[0].uuid })
          if (res.data) {
            this.$message.warning(this.$t('SeaExport.ItFreightAndRepeatedAllowed'))
            loading.close()
          } else {
            res = await ediApi.sendGoFreight({ jobNo: rows[0].jobNo, currentOfficeId: this.$store.getters.currentOfficeId })
            loading.close()
            if (res.data === this.$t('SeaExport.SentSuccessfully')) {
              this.$message.success(this.$t('SeaExport.SentSuccessfully'))
              this.$confirm(this.$t('SeaExport.CheckTheSendingLog'), this.$t('SeaExport.SentSuccessfully'), {
                confirmButtonText: this.$t('common.btn.ok'),
                cancelButtonText: this.$t('common.btn.cancel'),
                closeOnClickModal: false,
                type: 'info'
              }).then(async() => {
                this.queryGoFreightLog(rows[0].uuid)
              }).catch(() => {})
            } else {
              this.$message.success(this.$t('Message.SendFailed'))
            }
          }
        } catch {
          loading.close()
        }
      }
    },
    // 查看发送日志
    querySendLog(rows) {
      if (rows.length === 0) {
        this.$message.warning(this.$t('SeaExport.PleaseToViewTheLog'))
      } else if (rows.length > 1) {
        this.$message.warning(this.$t('SeaExport.OnlyToViewTheSelect'))
      } else {
        this.queryGoFreightLog(rows[0].uuid)
      }
    },
    queryGoFreightLog(jobUuid) {
      this.goFreightLogDialog.jobUuid = jobUuid
      this.goFreightLogDialog.visible = true
    },
    // 【SCFI申报】下拉菜单选择触发事件路由
    toScfi(value) {
      switch (value) {
        case 'scfi.booking_price.select_data': // 订舱运价/选中数据申报 190010
          this.scfiHandler().scfiCommitDeclarationHandler(190010)
          break
        case 'scfi.booking_price.none_data': // 订舱运价/空提交申报 190010
          this.scfiHandler().scfiCommitNoneHandler(190010)
          break
        case 'scfi.settle_price.select_data': // 结算运价.选中数据申报 190020
          this.scfiHandler().scfiCommitDeclarationHandler(190020)
          break
        case 'scfi.settle_price.none_data': // 结算运价.空提交申报 190020
          this.scfiHandler().scfiCommitNoneHandler(190020)
          break
        case 'scfi.record': // 申报记录
          this.scfiHandler().viewScfiHistoryEvent(null)
          break
      }
    },
    // 【99路电子装箱单】下拉菜单选择触发事件路由
    toElectronicPacking(value) {
      switch (value) {
        case 'electronicPacking.electronicPacking':
          this.electronicPackingHandler().eContainer99LuSendHandler()
          break
        case 'electronicPacking.history':
          this.electronicPackingHandler().eContainerHistoryShowHandler()
          break
      }
    },
    // 操作选项路由 === <<<
    // >>> === 具体操作处理器
    // 订舱操作处理器
    bookingHandler() {
      const self = this
      let exportJob = null
      // 选择事件 - booking.origin.FTP
      const btnBookingEdiNewClickHandler = async() => {
        await self.common().selectedJobItemClick()
        if (self.common().checkConfig('creditOpen', '1')) {
          const accountKey = self.globalVar.selectedJob.customerId
          checkCreditInfo({ [accountKey]: accountKey, jobUuid: self.globalVar.selectedJob.uuid }).then(resp => {
            let canEdit = true
            const creditInfo = resp.data !== null ? resp.data[0] : null
            if (creditInfo) {
              let tip = ''
              if (creditInfo.amountExceeded || creditInfo.dateExceeded) {
                const config = {}
                const creditBlock = this.configMap.get('creditBlockEDI').split(',')
                creditBlock.forEach(c => {
                  config[c.split('-')[0]] = c.split('-')[1] === '1'
                })
                if (config.booking) {
                  const isEffective = JobUtils.isEffective(self.globalVar.selectedJob)
                  if (!isEffective) {
                    if (creditInfo.amountExceeded) {
                      tip += this.$t('Partners.limit')
                    }
                    if (creditInfo.dateExceeded) {
                      tip += this.$t('Partners.accountPeriod')
                    }
                    canEdit = false
                    self.$message.info(this.$t('SeaExport.CreditControlTheClient') + tip + this.$t('SeaExport.HasExceededCannotEDI'))
                  }
                }
              }
            }
            if (canEdit) {
              self.globalVar.title = this.$t('SeaExport.BookingEDI')
              self.globalVar.ediType = 1
              self.globalVar.editStatus = 9
              if (self.common().checkConfig('useEDITemplate', '1')) {
                self.common().showEDITemplateWin(self.globalVar.selectedJobKeys)
              } else {
                getBookingEDI(self.globalVar.selectedJobKeys)
              }
            }
          })
        } else {
          self.globalVar.title = this.$t('SeaExport.BookingEDI')
          self.globalVar.ediType = 1
          self.globalVar.editStatus = 9
          if (self.common().checkConfig('useEDITemplate', '1')) {
            self.common().showEDITemplateWin(self.globalVar.selectedJobKeys)
          } else {
            getBookingEDI(self.globalVar.selectedJobKeys)
          }
        }
      }
      // 选择事件 - booking.correct.FTP
      const btnBookingEdiEditClickHandler = async() => {
        await self.common().selectedJobItemClick()
        if (self.common().checkConfig('creditOpen', '1')) {
          const accountKey = self.globalVar.selectedJob.customerId
          checkCreditInfo({ [accountKey]: accountKey, jobUuid: self.globalVar.selectedJob.uuid }).then(resp => {
            let canEdit = true
            const creditInfo = resp.data !== null ? resp.data[0] : null
            if (creditInfo) {
              let tip = ''
              if (creditInfo.amountExceeded || creditInfo.dateExceeded) {
                const config = {}
                const creditBlock = this.configMap.get('creditBlockEDI').split(',')
                creditBlock.forEach(c => {
                  config[c.split('-')[0]] = c.split('-')[1] === '1'
                })
                if (config.booking) {
                  const isEffective = JobUtils.isEffective(self.globalVar.selectedJob)
                  if (!isEffective) {
                    if (creditInfo.amountExceeded) {
                      tip += this.$t('Partners.limit')
                    }
                    if (creditInfo.dateExceeded) {
                      tip += this.$t('Partners.accountPeriod')
                    }
                    canEdit = false
                    self.$message.info(this.$t('SeaExport.CreditControlTheClient') + tip + this.$t('SeaExport.HasExceededCannotEDI'))
                  }
                }
              }
            }
            if (canEdit) {
              self.globalVar.title = this.$t('SeaExport.BookingCorrection')
              self.globalVar.ediType = 1
              self.globalVar.editStatus = 4
              if (self.common().checkConfig('useEDITemplate', '1')) {
                self.common().showEDITemplateWin(self.globalVar.selectedJobKeys)
              } else {
                getBookingEDI(self.globalVar.selectedJobKeys)
              }
            }
          })
        } else {
          self.globalVar.title = this.$t('SeaExport.BookingCorrection')
          self.globalVar.ediType = 1
          self.globalVar.editStatus = 4
          if (self.common().checkConfig('useEDITemplate', '1')) {
            self.common().showEDITemplateWin(self.globalVar.selectedJobKeys)
          } else {
            getBookingEDI([self.globalVar.selectedJob.uuid])
          }
        }
      }
      // 订舱回执导入 选择事件 - booking.import
      const btnBookingEdiReceiptClickHandler = async() => {
        await self.common().selectedJobItemClick()
        self.$refs['importFile'].click()
      }

      // >>>====== 内部和涉及各类弹窗回调方法 <<<=====
      // 获取订舱EDI
      const getBookingEDI = (selectedKeys) => {
        const params = {
          jobUuids: selectedKeys,
          editStatus: self.globalVar.editStatus
        }
        self.loading = getLoading4Cxt(this)
        ediApi.getBookingEDI(params).then(result => { self.commonCallback().onExportEDISuccess(result) })
          .catch(message => { self.commonCallback().onExportEDIFail(message) })
          .finally(() => { self.loading.close() })
      }
      // 订舱-回执导入请求成功回调方法
      const onImportSucceeded = (response) => {
        exportJob = response.data
        const job = self.globalVar.selectedJob
        if (self.common().needLoadCargoDoc(job)) {
          self.loading = getLoading4Cxt(this)
          const params = { jobUuid: job.uuid }
          jobApi.getCargoDoc(params).then(result => {
            job.cargoDoc = result.data
            loadCargoDocHandler()
          }).finally(() => { self.loading.close() })
        } else {
          loadCargoDocHandler()
        }
      }
      // 加载CargoDoc请求成功回调方法
      const loadCargoDocHandler = async() => {
        const job = self.globalVar.selectedJob
        if (exportJob == null) {
          self.$message.info('回执单导入失败!')
          return
        }
        if (exportJob.mbl !== job.mbl) {
          await this.$confirm(this.$t('SeaExport.PrimaryOrderNotSameReceipt'), this.$t('Message.Confirm'), { type: 'info' })
          updateSeaJobsFromReceipt()
        } else {
          updateSeaJobsFromReceipt()
        }
      }
      // 从接收返回的exportJob更新seaJob
      const updateSeaJobsFromReceipt = () => {
        const job = self.globalVar.selectedJob
        const docs = job.cargoDoc
        const bool = docs.find(doc => doc.docType === MBL && doc.cfmState === 0)
        if (!bool) {
          self.$message.warning('该票MBL对单状态不是未开始，无法导入。')
          return
        }
        self.loading = getLoading4Cxt(this)
        exportJob.oldJobUuid = job.uuid
        jobApi.updateSeaJobsFromReceipt(exportJob).then(response => onReceiptupdateSucceeded(response))
          .finally(() => { self.loading.close() })
      }
      // 从接收返回的exportJob更新seaJob - 请求成功回调方法
      const onReceiptupdateSucceeded = (response) => {
        self.loading = getLoading4Cxt(this)
        const data = {
          jobUuid: self.globalVar.selectedJobKey,
          filedCode: '_edi_receipt_import'
        }
        trackingApi.updateTrackingByEvent(data).then(response => {
          self.$message.success(this.$t('SeaExport.ReceiptImportedSuccessfully'))
        }).finally(() => { self.loading.close() })
      }

      return { btnBookingEdiNewClickHandler, btnBookingEdiEditClickHandler,
        btnBookingEdiReceiptClickHandler, onImportSucceeded }
    },
    // 提单操作处理器
    blHandler() {
      const self = this
      // 选择事件 - bl.origin.FTP
      const btnBlEdiNewClickHandler = async() => {
        let selectedJobs = self.globalVar.selectedJobs
        // 假如没有勾选，把选中算上
        if ((!selectedJobs || selectedJobs.length === 0) && this.selectedJob) {
          selectedJobs = [this.selectedJob]
        }
        // 勾选业务记录，是否存在的判断
        if (selectedJobs.length === 0) {
          self.$message.warning(this.$t('SeaExport.NoBusinessSelected'))
          return
        }
        self.loading = getLoading4Cxt(this)
        const jobUuids = []
        for (const job of selectedJobs) {
          jobUuids.push(job.uuid)
        }
        jobApi.batchLoadJobContainers(jobUuids).then(response => {
          onContainerLoaded(response, selectedJobs)
        }).finally(() => self.loading.close())
      }
      // 选择事件 - bl.correct
      const btnBlEdiEditClickHandler = async() => {
        let selectedJobs = self.globalVar.selectedJobs
        // 假如没有勾选，把选中算上
        if ((!selectedJobs || selectedJobs.length === 0) && this.selectedJob) {
          selectedJobs = [this.selectedJob]
        }
        // 勾选业务记录，是否存在的判断
        if (selectedJobs.length === 0) {
          self.$message.warning(this.$t('SeaExport.NoBusinessSelected'))
          return
        }
        const accountKey = []
        let params = {}
        const selectedJobKeys = []
        for (const job of selectedJobs) {
          if (job.customerId && !accountKey.includes(job.customerId)) {
            accountKey.push(job.customerId)
            params = { ...params, [job.uuid]: job.customerId }
          }
          selectedJobKeys.push(job.uuid)
        }
        if (self.common().checkConfig('creditOpen', '1')) {
          batchCheckCreditInfoFunc(params).then(resp => {
            let canEdit = true
            if (resp.data && resp.data.length > 0) {
              for (const creditInfo of resp.data) {
                if (creditInfo) {
                  let tip = ''
                  if (creditInfo.amountExceeded || creditInfo.dateExceeded) {
                    const config = {}
                    const creditBlock = this.configMap.get('creditBlockEDI').split(',')
                    creditBlock.forEach(c => {
                      config[c.split('-')[0]] = c.split('-')[1] === '1'
                    })
                    if (config.bl) {
                      if (creditInfo.amountExceeded) {
                        tip += this.$t('Partners.limit')
                      }
                      if (creditInfo.dateExceeded) {
                        tip += this.$t('Partners.accountPeriod')
                      }
                      canEdit = false
                      self.$message.info(this.$t('SeaExport.CreditControlTheClient') + tip + this.$t('SeaExport.HasExceededCannotEDI'))
                    }
                  }
                }
              }
            }
            if (canEdit) {
              self.globalVar.title = this.$t('SeaExport.CorrectionBillOfLading')
              self.globalVar.ediType = 2
              self.globalVar.editStatus = 4
              if (self.common().checkConfig('useEDITemplate', '1')) {
                self.common().showEDITemplateWin(selectedJobKeys)
              } else {
                getLadingBillEDI(selectedJobKeys)
              }
            }
          })
        } else {
          self.globalVar.title = this.$t('SeaExport.CorrectionBillOfLading')
          self.globalVar.ediType = 2
          self.globalVar.editStatus = 4
          if (self.common().checkConfig('useEDITemplate', '1')) {
            self.common().showEDITemplateWin(selectedJobKeys)
          } else {
            getLadingBillEDI(selectedJobKeys)
          }
        }
      }

      // >>>====== 内部和涉及各类弹窗回调方法 <<<=====
      // 添加提单edi
      const onContainerLoaded = (response, selectedJobs) => {
        for (const data of selectedJobs) {
          data.containers = response.data[data.uuid]
        }
        addBillEdi(selectedJobs)
      }
      const checkContainerUsage = (selectedJobs) => {
        if (self.common().checkConfig('ExportEdiCheckContainerUsage', '0')) {
          return true
        }
        // 循环检查业务中箱件毛体，有一笔业务错误，直接返回
        for (const job of selectedJobs) {
          // dataType 区分拆并单数据 业务数据，1 主票 2 小票 3 MBL 4 MBL2 5 HBL2
          if (Number(job.dataType) === 4 || Number(job.dataType) === 5) {
            continue
          }
          let totalQuantity = 0
          let totalWeight = 0.0
          let totalCubage = 0.0
          for (const index in job.containers) {
            const container = job.containers[index]
            for (const index1 in container.containerUsage) {
              const containerUsage = container.containerUsage[index1]
              totalQuantity += containerUsage.quantity
              totalWeight += containerUsage.weight
              totalCubage += containerUsage.cubage
            }
          }
          totalQuantity = Number(totalQuantity.toFixed())
          totalWeight = Number(totalWeight.toFixed(3))
          totalCubage = Number(totalCubage.toFixed(3))
          if (totalQuantity !== (job.quantityActual ? job.quantityActual : 0)) {
            return false
          }
          let diff = Math.abs(totalWeight - (job.weightActual ? job.weightActual : 0))
          if (diff > 0.001) return false// special handlement for floating number.

          diff = Math.abs(totalCubage - (job.cubageActual ? job.cubageActual : 0))
          if (diff > 0.001) {
            return false
          }
        }
        return true
      }
      const addBillEdi = (selectedJobs) => {
        let params = {}
        const accountKey = []
        const selectedJobKeys = []
        for (const job of selectedJobs) {
          if (job.customerId && !accountKey.includes(job.customerId)) {
            accountKey.push(job.customerId)
            params = { ...params, [job.uuid]: job.customerId }
          }
          selectedJobKeys.push(job.uuid)
        }
        if (self.common().checkConfig('creditOpen', '1')) {
          batchCheckCreditInfoFunc(params).then(resp => {
            let canEdit = true
            for (const accountId of accountKey) {
              const creditInfo = resp.data ? resp.data[accountId] : null
              if (creditInfo) {
                let tip = ''
                if (creditInfo.amountExceeded || creditInfo.dateExceeded) {
                  const config = {}
                  const creditBlock = this.configMap.get('creditBlockEDI').split(',')
                  creditBlock.forEach(c => {
                    config[c.split('-')[0]] = c.split('-')[1] === '1'
                  })
                  if (config.bl) {
                    if (creditInfo.amountExceeded) {
                      tip += this.$t('Partners.limit')
                    }
                    if (creditInfo.dateExceeded) {
                      tip += this.$t('Partners.accountPeriod')
                    }
                    canEdit = false
                    self.$message.info(this.$t('SeaExport.CreditControlTheClient') + tip + this.$t('SeaExport.HasExceededCannotEDI'))
                  }
                }
              }
            }
            if (canEdit) {
              if (checkContainerUsage(selectedJobs)) {
                self.globalVar.title = this.$t('SeaExport.BlEdi')
                self.globalVar.ediType = 2
                self.globalVar.editStatus = 9
                if (self.common().checkConfig('useEDITemplate', '1')) {
                  self.common().showEDITemplateWin(selectedJobKeys)
                } else {
                  getLadingBillEDI(selectedJobKeys)
                }
              } else {
                self.$message.info(this.$t('SeaExport.PackingDataNotCconsistent'))
              }
            }
          })
        } else {
          if (checkContainerUsage(selectedJobs)) {
            self.globalVar.title = this.$t('SeaExport.BlEdi')
            self.globalVar.ediType = 2
            self.globalVar.editStatus = 9
            if (self.common().checkConfig('useEDITemplate', '1')) {
              self.common().showEDITemplateWin(selectedJobKeys)
            } else {
              getLadingBillEDI(selectedJobKeys)
            }
          } else {
            self.$message.info(this.$t('SeaExport.PackingDataNotCconsistent'))
          }
        }
      }
      const getLadingBillEDI = (selectedJobKeys) => {
        self.loading = getLoading4Cxt(this)
        const params = {
          jobUuid: selectedJobKeys,
          editStatus: self.globalVar.editStatus
        }
        ediApi.getLadingBillEDI(params).then(reponse => {
          self.commonCallback().onExportEDISuccess(reponse)
        }).catch(err => {
          self.commonCallback().onExportEDIFail(err)
        }).finally(() => {
          self.loading.close()
        })
      }

      return { btnBlEdiNewClickHandler, btnBlEdiEditClickHandler }
    },
    // VGM操作处理器
    async vgmHandler() {
      const self = this
      await self.common().selectedJobItemClick()
      if (self.common().checkConfig('useEDITemplate', '1')) {
        self.common().showEDITemplateWin([self.globalVar.selectedJobKey])
      } else {
        self.loading = getLoading4Cxt(this)
        const params = {
          jobUuid: self.globalVar.selectedJobKey,
          editStatus: self.globalVar.editStatus
        }
        ediApi.getVGMEDI(params).then(response => {
          self.commonCallback().onExportEDISuccess(response)
        }).catch(err => {
          self.commonCallback().onExportEDIFail(err)
        }).finally(() => {
          self.loading.close()
        })
      }
    },
    // 海外代理预报操作处理器
    shamHandler() {
      const self = this
      const sendOverseasAgentsEvent = async() => {
        await self.common().selectedJobItemClick()
        self.globalVar.title = this.$t('SeaExport.OverseasAgentEDI')
        self.globalVar.ediType = 3
        self.globalVar.ediTemplate = {}
        self.globalVar.ediTemplate.defaultFileType = '.XML'
        self.loading = getLoading4Cxt(this)
        const params = {
          jobUuid: self.globalVar.selectedJobKey
        }
        ediApi.getOverseaAgentEDI(params).then(response => {
          self.commonCallback().onExportEDISuccess(response)
        }).catch(err => {
          self.commonCallback().onExportEDIFail(err)
        }).finally(() => {
          self.loading.close()
        })
      }
      const sendCargoWiseEvent = async() => {
        await self.common().selectedJobItemClick()
        self.globalVar.title = this.$t('SeaExport.OverseasAgentEDI')
        self.globalVar.ediType = 15
        self.globalVar.ediTemplate = {}
        self.globalVar.ediTemplate.defaultFileType = '.XML'
        self.loading = getLoading4Cxt(this)
        if (self.common().checkConfig('useEDITemplate', '1')) {
          self.common().showEDITemplateWin([self.globalVar.selectedJobKey])
        } else {
          self.loading = getLoading4Cxt(this)
          const params = {
            jobUuid: self.globalVar.selectedJobKey
          }
          ediApi.getCargoWiseEDI(params).then(response => {
            self.commonCallback().onExportEDISuccess(response)
          }).catch(err => {
            self.commonCallback().onExportEDIFail(err)
          }).finally(() => {
            self.loading.close()
          })
        }
      }
      const sendKinNitEvent = async type => {
        await self.common().selectedJobItemCheck()
        const jobs = self.globalVar.selectedJobs
        if (jobs.length > 50) {
          this.$message.warning(this.$t('SeaExport.ItUpTo50Businesses'))
          return
        }
        const sendJobKeys = []
        let errorContainerTypeJobs = ''
        for (const item of jobs) {
          // dataType 区分拆并单数据 业务数据，1 主票 2 小票 3 MBL 4 MBL2 5 HBL2
          if (Number(item.dataType) === 1 || Number(item.dataType) === 2) {
            sendJobKeys.push(item.uuid)
            if (item.containerLoadType !== 'FCL' && item.containerLoadType !== 'LCL') {
              errorContainerTypeJobs += item.jobNo + '\n'
            }
          }
        }
        if (errorContainerTypeJobs) {
          this.$message.warning(this.$t('SeaExport.Business') + errorContainerTypeJobs + this.$t('SeaExport.NonIntegralType'))
          return
        }
        const loading = getLoading4Cxt(this)
        ediApi.sendKinNit({ jobUuids: sendJobKeys, type }).then(res => {
          if (res.data === this.$t('SeaExport.SendComplete')) {
            this.$message.success(this.$t('SeaExport.SendComplete'))
          } else {
            this.$message.warning(res.data)
          }
        }).finally(() => {
          loading.close()
        })
      }
      return { sendOverseasAgentsEvent, sendCargoWiseEvent, sendKinNitEvent }
    },
    // 安装箱操作处理器
    async packingHandler() {
      const self = this
      await self.common().selectedJobItemClick()
      this.ediStatusName = this.$t('SeaExport.Send') + this.$t('SeaExport.AnnPackingList')
      this.globalVar.title = this.$t('SeaExport.PackingList')
      this.globalVar.ediType = 4
      this.globalVar.editStatus = 9
      if (this.common().checkConfig('useEDITemplate', '1')) {
        this.common().showEDITemplateWin([this.globalVar.selectedJobKey])
      } else {
        this.loading = getLoading4Cxt(this)
        const params = {
          jobUuid: self.globalVar.selectedJobKey
        }
        ediApi.getInstallEDI(params).then(response => {
          self.commonCallback().onExportEDISuccess(response)
        }).catch(err => {
          self.commonCallback().onExportEDIFail(err)
        }).finally(() => {
          self.loading.close()
        })
      }
    },
    // 预配舱单操作处理器
    preShippingHandler() {
      const self = this
      // 原始
      const btnPreShippingEdiClickHandler = () => {
        self.globalVar.title = this.$t('SeaExport.PreShippingBill')
        self.globalVar.editStatus = 9
        preShippingHandler()
      }
      // 更正
      const btnPreShippingEdiUpdateClickHandler = () => {
        self.globalVar.title = this.$t('SeaExport.CorrectionOfPreAllocatedManifest')
        self.globalVar.editStatus = 5
        preShippingHandler()
      }
      // 删除
      const btnPreShippingEdiDeleteClickHandler = () => {
        self.globalVar.title = this.$t('SeaExport.PreConfiguredManifestDeletion')
        self.globalVar.editStatus = 4
        preShippingHandler()
      }

      // >>> === 内部或相关方法
      const preShippingHandler = () => {
        self.globalVar.ediType = 6
        self.globalVar.ediTemplate = {}
        self.globalVar.ediTemplate.defaultFileType = '.txt'
        if (self.common().checkConfig('useEDITemplate', '1')) {
          self.common().showEDITemplateWin(self.globalVar.selectedJobKeys)
        } else {
          const params = {
            jobUuids: self.globalVar.selectedJobKeys,
            editStatus: self.globalVar.editStatus
          }
          self.loading = getLoading4Cxt(this)
          ediApi.getPreshippingEDI(params).then(response => {
            self.commonCallback().onExportEDISuccess(response)
          }).catch(err => {
            self.commonCallback().onExportEDIFail(err)
          }).finally(() => {
            self.loading.close()
          })
        }
      }
      // 内部或相关方法 === <<<
      return { btnPreShippingEdiClickHandler, btnPreShippingEdiUpdateClickHandler, btnPreShippingEdiDeleteClickHandler }
    },
    // 舱单操作处理器
    shippingHandler() {
      const self = this
      // 主处理方法
      const handle = () => {
        this.globalVar.title = this.$t('SeaExport.ShippingBill')
        this.globalVar.ediType = 5
        this.globalVar.editStatus = 9
        this.globalVar.ediTemplate = {}
        this.globalVar.ediTemplate.defaultFileType = '.txt'
        if (this.common().checkConfig('useEDITemplate', '1')) {
          this.common().showEDITemplateWin(this.globalVar.selectedJobKeys)
        } else {
          if (this.common().checkConfig('EDINoRuleConfigMode', '1')) {
            this.globalVar.popMultiSegNumRulesType = 2
            this.multiSegNumRulesDialog.visible = true
          } else {
            getShippingEDI(null)
          }
        }
      }

      // >>> === 内部或相关方法
      const getShippingEDI = (ruleEDINos) => {
        const params = {
          map: {
            selectedJobs: self.globalVar.selectedJobKeys,
            ruleEDINos: ruleEDINos || null
          }
        }
        self.loading = getLoading4Cxt(this)
        ediApi.getShippingEDI(params).then(response => {
          self.commonCallback().onExportEDISuccess(response)
        }).catch(err => {
          self.commonCallback().onExportEDIFail(err)
        }).finally(() => {
          self.loading.close()
        })
      }
      // 内部或相关方法 === <<<
      return { handle, getShippingEDI }
    },
    // 反恐舱单操作处理器
    afrHandler() {
      const self = this
      // 反恐舱单操作
      const btnAFREdiClickHandler = async() => {
        self.globalVar.ediType = 8
        self.globalVar.ediTemplate = {}
        self.globalVar.ediTemplate.defaultFileType = '.txt'
        const selectedJobs = []
        const jobs = self.globalVar.selectedJobs
        for (let job of jobs) {
          job = await new SeaExportJob(job)
          if (!job.masterFlag) {
            const item = getGroupLCLSelectItems(selectedJobs, job)
            const itemValue = {}
            if (item === null) {
              itemValue.uuid = await job.getLclMaster() ? job.lclMaster.uuid : null
              const lclSlaves = []
              lclSlaves.push(job.uuid)
              itemValue.lclSlaves = lclSlaves
              selectedJobs.push(itemValue)
            }
          }
        }
        // 勾选业务记录，是否存在的判断
        if (selectedJobs.length === 0) {
          self.$message.warning(this.$t('SeaExport.NoBusinessSelected'))
          return
        }
        const exportItem = {}
        // exportItem请求对象的拼接
        exportItem.jobs = converSelectedJobsToParam(selectedJobs)
        if (this.common().checkConfig('useEDITemplate', '1')) {
          this.common().showEDITemplateWin(null, exportItem)
        } else {
          const params = {
            exportItem: exportItem,
            editStatus: self.globalVar.editStatus
          }
          self.loading = getLoading4Cxt(this)
          ediApi.getJP24EDI(params).then(response => {
            self.commonCallback().onExportEDISuccess(response)
          }).catch(err => {
            self.commonCallback().onExportEDIFail(err)
          }).finally(() => {
            self.loading.close()
          })
        }
      }
      const btnAFRClickAPIHandler = async() => {
        // 勾选业务记录，是否存在的判断
        if (self.globalVar.selectedJobKey.length === 0) {
          self.$message.warning(this.$t('SeaExport.NoBusinessSelected'))
          return
        }
        self.loading = getLoading4Cxt(this)
        const param = {
          departmentCode: this.$store.getters.currentDept.code,
          jobUuid: self.globalVar.selectedJobKey,
          officeId: this.$store.getters.currentOfficeId,
          editStatus: self.globalVar.editStatus
        }
        ediApi.getEFreight(param).then(res => {
          this.commonCallback().onApiSuccess(res)
        }).finally(() => {
          self.loading.close()
        })
      }
      // 反恐地址格式化
      const btnAFRAddressClickHandler = async() => {
        await self.common().selectedJobItemCheck()
        const jobUuids = []
        const selectedJobs = self.globalVar.selectedJobs
        for (const job of selectedJobs) {
          if (!job.masterFlag) {
            jobUuids.push(job.uuid)
          }
        }
        if (!jobUuids || jobUuids.length === 0) {
          self.$message.warning(this.$t('SeaExport.NoBusinessSelected'))
          return
        }
        const params = {
          jobUuids: jobUuids
        }
        self.loading = getLoading4Cxt(this)
        ediApi.queryJobsCargoDoc(params).then(resp => {
          queryJobsCargoDocHandler(resp)
        }).finally(() => {
          self.loading.close()
        })
      }
      // === >>> 内部方法
      const queryJobsCargoDocHandler = (resp) => {
        const result = resp.data
        const cargoDocs = []
        for (let i = result.length - 1; i >= 0; i--) {
          const cargoDocArray = result[i].seaCargoDoc
          for (const cargoDoc of cargoDocArray) {
            // if (cargoDoc.docType == CargoDocConsts.HBL || cargoDoc.docType == CargoDocConsts.HBL2)
            if (cargoDoc.docType === HBL) {
              cargoDocs.push(cargoDoc)
              break
            }
          }
        }
        if (cargoDocs.length === 0) {
          self.$message.warning(this.$t('SeaExport.NoBillOfLadingInformation'))
          return
        }
        // addressFormatDialog弹窗
        self.addressFormatDialog.params = { cargoDocs: cargoDocs }
        self.addressFormatDialog.visible = true
      }
      // 只传小票或者单个主票或者FCL
      const converSelectedJobsToParam = (selectedJobs) => {
        const list = []
        for (let i = selectedJobs.length - 1; i >= 0; i--) {
          const job = selectedJobs[i]
          const lclSlaves = job.lclSlaves
          const item = {}
          if (lclSlaves && lclSlaves.length > 0) {
            item.jobList = lclSlaves
          } else {
            item.jobList = [job.uuid]
          }
          list.push(item)
        }
        return list
      }
      // 按小票分组
      const getGroupLCLSelectItems = (selectedJobs, job) => {
        for (let i = selectedJobs.length - 1; i >= 0; i--) {
          const item = selectedJobs[i]
          const lclSlaves = item.lclSlaves
          const lclSlavesUuids = lclSlaves.map(item => item.uuid)
          if (job.masterFlag || job.lclMaster) {
            if (job.lclMaster && item.uuid === job.lclMasterUuid && !lclSlavesUuids.includes(job.uuid)) {
              lclSlaves.push(job.uuid)
              return item
            }
          } else {
            if (item.uuid === job.uuid && !lclSlavesUuids.includes(job.uuid)) {
              return item
            }
          }
        }
        return null
      }
      // 内部方法 === <<<
      return { btnAFREdiClickHandler, btnAFRClickAPIHandler, btnAFRAddressClickHandler }
    },
    // 清洁舱单操作处理器
    async clearHandler() {
      this.globalVar.title = this.$t('SeaExport.CleanShipping')
      this.ediStatusName = this.$t('SeaExport.CleanShipping')
      this.globalVar.ediType = 7
      this.globalVar.editStatus = 9
      this.globalVar.ediTemplate = {}
      this.globalVar.ediTemplate.defaultFileType = '.txt'
      if (this.common().checkConfig('useEDITemplate', '1')) {
        this.common().showEDITemplateWin(this.globalVar.selectedJobKeys)
      } else {
        this.globalVar.ediTemplate = null
        const params = {
          jobUuids: this.globalVar.selectedJobKeys,
          editStatus: this.globalVar.editStatus
        }
        const self = this
        self.loading = getLoading4Cxt(this)
        ediApi.getIFCSUMEDI(params).then(resp => {
          self.commonCallback().onExportEDISuccess(resp)
        }).catch(err => {
          self.commonCallback().onExportEDIFail(err)
        }).finally(() => {
          self.loading.close()
        })
      }
    },
    // 提箱操作处理器
    suitcaseHandler() {
      const self = this
      this.ediStatusName = this.$t('SeaExport.Suitcase')
      const handle = () => {
        this.apiPopup.title = this.$t('SeaExport.Suitcase') + 'API'
        this.apiPopup.interfaceType = 3
        this.apiPopup.interfaceArray = this.configMap.get('SuitcaseEDIApiOpen')
        this.apiPopup.callback = data => {
          const inteface = data.id
          if (inteface === '1') {
            const selectedJobs = self.globalVar.selectedJobs
            for (const index in selectedJobs) {
              if (selectedJobs[index].containerLoadType !== 'FCL') {
                self.$message.warning(this.$t('SeaExport.PleaseContainerBusinessForOperation'))
                return
              }
            }
            this.$message.info(this.$t('SeaExport.EmptyInterfaceSendingPleaseWait'))
            self.loading = getLoading4Cxt(this)
            const params = {
              jobUuids: self.globalVar.selectedJobKeys,
              btnFlag: '0',
              officeID: self.currentOfficeId
            }
            ediApi.issuedSuitcase(params).then(resp => {
              queryHandles(resp)
            }).finally(() => {
              self.loading.close()
            })
          } else if (inteface === '2') {
            this.ningBoEportAPI('9', 'NBPCLP')
          }
        }
        this.apiPopup.visible = true
      }
      // 查询回调
      const queryHandles = (resp) => {
        const result = resp.data
        // 0000  表示受理成功
        if (result.msgId === '0000') {
          // 发起提箱业务请求
          self.$message.info(result.msgDESC)
          // eslint-disable-next-line brace-style
        }
        // 9999 其他平台错误
        else if (result.msgId === '9999') {
          self.$message.info(result.msgDESC)
        } else if (result.msgId === '0001') {
          self.$message.warning(result.msgDESC)
        }
      }
      return { handle }
    },
    /**
     * 中外运api 原始
     * edistate 9：新增  5：修改 1：取消
     * type:请求类型
     */
    async ningBoEportAPI(edistate, type) {
      await this.common().selectedJobItemClick()
      const loading = getLoading4Cxt(this)
      let ediSendType = 0
      if (edistate === '9') {
        ediSendType = EdiSendType.EDI_ORIGINAL_API.code
      } else if (edistate === '5') {
        ediSendType = EdiSendType.EDI_UPDATE_API.code
      }
      ediApi.getNingBoEportAPI({ jobUuid: this.globalVar.selectedJobKey, editStatus: Number(edistate), sendType: type, ediSendType: ediSendType }).then(res => {
        this.commonCallback().onApiSuccess(res)
      }).finally(() => {
        loading.close()
      })
    },
    // SCFI申报操作处理器
    scfiHandler() {
      // 选中数据申报
      const scfiCommitDeclarationHandler = async(filingType) => {
        const keys = []
        const jobList = []
        const jobs = this.gridOptions.api.getSelectedRows().filter(p => Number(p.dataType) === 1 || Number(p.dataType) === 2)

        for (const job of jobs) {
          keys.push(job.uuid)
          jobList.push(job)
        }
        if (keys.length === 0) {
          this.$message.warning(this.$t('SeaExport.NoBusinessSelected'))
          return
        }

        // 校验数据是否符合申报格式
        const checkMsg = await this.checkJobHandler(jobList)
        // 校验结果信息弹出对话框提示
        if (checkMsg.length > 0) {
          const checkMessageList = []
          for (const data of checkMsg) {
            const node = {}
            node['type'] = 'node'
            node['name'] = data['name']
            if (!checkMessageList.includes(node)) {
              checkMessageList.push(node)
            }
            for (const item of data['detail']) {
              const obj = {}
              obj['type'] = 'failure'
              obj['name'] = item
              if (!checkMessageList.includes(obj)) {
                checkMessageList.push(obj)
              }
            }
          }
          // 显示对话框
          const currentState = 'failure'
          const title = this.$t('SeaExport.VerificationOfDeclarationData')
          const labelText = this.$t('SeaExport.DataCheckTheDataAgain')
          const params = { checkMessageList, currentState, title, labelText }
          this.ediScfiPromptDialog.visible = true
          this.ediScfiPromptDialog.params = params
        } else {
          await this.$confirm(this.$t('SeaExport.PleaseWhetherToSubmitThis') + keys.length + this.$t('SeaExport.TicketData'), this.$t('FileHistory.Tips'), { type: 'info' })
          ediApi.commitDeclaration(keys, filingType).then(resp => {
            if (resp.code === '0') {
              this.$message.success(this.$t('SeaExport.DataDeclarationSucceeded'))
            }
          }).catch(err => {
            this.$message.error(err)
          })
        }
      }
      // 空数据申报
      const scfiCommitNoneHandler = (filingType) => {
        ediApi.commitNone(filingType).then(resp => {
          if (resp.code === '0') {
            this.$message.success(this.$t('SeaExport.EmptySubmittedSuccessfully'))
          }
        }).catch(err => {
          this.$message.error(err)
        })
      }
      // 申报记录
      const viewScfiHistoryEvent = (filingType) => {
        this.declarateRecordDialog.visible = true
      }
      // === >>> 内部方法
      // 内部方法 === <<<
      return { scfiCommitDeclarationHandler, scfiCommitNoneHandler, viewScfiHistoryEvent }
    },
    // 导出excel操作处理器
    exportHandler() {
      const selectedRows = this.gridOptions.api.getSelectedRows().filter(p => Number(p.dataType) === 1 || Number(p.dataType) === 2)
      const self = this
      if (selectedRows.length === 0) {
        self.$message.warning(this.$t('SeaExport.NotData'))
        return
      }
      const rows = lodash.cloneDeep(selectedRows)
      var timestamp = new Date().getTime()
      console.log('====开始时间======', timestamp)
      // 获取显示列
      const allDisplayedColumns = this.gridOptions.columnApi.getAllDisplayedColumns()
      // 获取选中行
      const fileName = `EDI${this.$t('CargoMsg.Cargo_list')}.xls`
      exportExcel(fileName, rows, allDisplayedColumns, true)
    },
    // 查看历史操作处理器
    async historyHandler() {
      let jobUuid = this.globalVar.selectedJobKey
      if (!jobUuid && this.rowData) {
        jobUuid = this.rowData[0].uuid
      }
      const params = { jobUuid: jobUuid }
      this.loading = getLoading4Cxt(this)
      const self = this
      ediApi.getEdiHistory(params).then(resp => {
        self.showHistoryDialog.params = { data: resp.data }
        self.showHistoryDialog.visible = true
      }).finally(() => {
        self.loading.close()
      })
    },
    // 99路电子装箱单操作处理器
    electronicPackingHandler() {
      const self = this
      // 99路电子装箱单
      const eContainer99LuSendHandler = () => {
        const selectedJobKeys = self.globalVar.selectedJobKeys
        if (selectedJobKeys.length < 1) {
          self.$message.warning(this.$t('SeaExport.ThereElectronicPackingListData'))
        }
        self.loading = getLoading4Cxt(this)
        ediApi.sendEDIEContainer(selectedJobKeys).then(resp => {
          eContainer99LuSuccess(resp)
        }).finally(() => {
          self.loading.close()
        })
      }
      // 发送历史
      const eContainerHistoryShowHandler = () => {
        const jobUuid = self.globalVar.selectedJobKey
        if (!jobUuid) {
          return
        }
        const params = { jobUuid: jobUuid }
        self.loading = getLoading4Cxt(this)
        ediApi.queryEContainerHistories(params).then(resp => {
          self.econtainerHistoryDialog.params = { data: resp.data }
          self.econtainerHistoryDialog.visible = true
        }).finally(() => {
          self.loading.close()
        })
      }
      // === >>> 内部方法
      const eContainer99LuSuccess = (resp) => {
        const result = resp.data
        if (result === 'success') {
          self.$message.success(this.$t('Message.SuccessfullySent'))
        } else {
          self.$message.error(this.$t('SeaExport.SendFailed') + result)
        }
      }
      // 内部方法 === <<<
      return { eContainer99LuSendHandler, eContainerHistoryShowHandler }
    },
    // 具体操作处理器 === <<<
    // >>> === 公用方法及特殊回调方法
    // EDI公共方法
    common() {
      const self = this
      // configMap检测方法
      const checkConfig = (prop, targetValue) => {
        return self.configMap !== null && self.configMap.get(prop) === targetValue
      }
      // 获取selectedJobs & 拼接各类所需对象
      const getSelectedJobs = () => {
        if (!self.rowData || self.rowData.length < 1) {
          return
        }
        // 点击行
        const selectedJob = this.selectedJob
        if (selectedJob) {
          self.globalVar.selectedJob = selectedJob
          self.globalVar.selectedJobKey = selectedJob.uuid
        }
        // 勾选行
        const selectedJobs = getGridSelected(self.gridOptions)
        self.globalVar.selectedJobs = selectedJobs
        if (selectedJobs && selectedJobs.length > 0) {
          self.globalVar.selectedJobKeys = selectedJobs.map(item => item.uuid)
        }
      }
      // 显示EDI模板选择弹窗(selectorDialog)
      const showEDITemplateWin = (uuids, item = null) => {
        if (uuids) {
          self.globalVar.ediTemplateWin.uuids = uuids
        } else {
          self.globalVar.ediTemplateWin.item = item
        }
        self.loading = getLoading4Cxt(this)
        getEDITemplate({ templateType: this.globalVar.ediType }).then(result => {
          self.selectorDialog.title = self.globalVar.title
          self.selectorDialog.rowData = result.data
          if (self.globalVar.sendRPA && self.selectorDialog.rowData) {
            self.selectorDialog.rowData = self.selectorDialog.rowData.filter(p => p.sendType === 'YD')
          }
          self.selectorDialog.visible = true
        }).finally(() => {
          self.loading.close()
        })
      }
      // 弹出messagePreviewDialog
      const setEdiTabWindow = () => {
        self.messagePreviewDialog.params = {
          job: self.globalVar.selectedJob,
          title: self.globalVar.title,
          ediType: self.globalVar.ediType,
          // ediFileName: self.globalVar,
          ediCollection: self.globalVar.ediDatas,
          ediTemplate: self.globalVar.ediTemplate,
          ediStatusName: self.ediStatusName,
          sendRPA: self.globalVar.sendRPA
        }
        if (self.globalVar.ediType === 1) {
          self.messagePreviewDialog.params.jobKeys = self.globalVar.selectedJobKeys
        }
        self.messagePreviewDialog.visible = true
      }
      // 判断SeaExportJob是否需要加载CargoDoc
      const needLoadCargoDoc = (job) => {
        return job.uuid && (job.cargoDoc == null || job.cargoDoc.length < 1)
      }
      // 判断SeaExportJob是否需要加载Containers
      const needLoadContainers = (job) => {
        return job.uuid && (job.containers == null || job.containers.length < 1)
      }
      // 判断数据选择情况(勾选行)
      const selectedJobItemCheck = () => {
        if (!self.globalVar.selectedJobKeys) {
          self.$message.warning(this.$t('SeaExport.NoBusinessSelected'))
          return Promise.reject()
        }
      }
      // 判断数据选择情况(点击行，非勾选)
      const selectedJobItemClick = () => {
        if (!self.globalVar.selectedJobKey) {
          self.$message.warning(this.$t('SeaExport.NoBusinessSelected'))
          return Promise.reject()
        }
      }
      return { checkConfig, getSelectedJobs, showEDITemplateWin, setEdiTabWindow, needLoadCargoDoc, needLoadContainers,
        selectedJobItemCheck, selectedJobItemClick }
    },
    // EDI公共回调方法
    commonCallback() {
      const self = this
      // edi导出成功回调方法
      const onExportEDISuccess = (response) => {
        if (!response || !response.data || JSON.stringify(response.data) === '{}') {
          self.$message.info(this.$t('SeaExport.NoImportEDI'))
          return
        }
        self.globalVar.ediDatas = response.data
        self.common().setEdiTabWindow()
      }
      // edi导出失败回调方法
      const onExportEDIFail = (dataMsg) => {
        if (dataMsg instanceof Error) {
          return
        }
        const modelMap = ModelMap['ProperyLabelMap']
        const errorMsgArr = dataMsg ? dataMsg.split(';') : null
        let finalMessage = ''
        const suffixMsg = this.$t('SeaExport.ItIsEmpty') + '<br/>'
        if (errorMsgArr && errorMsgArr.length > 0) {
          errorMsgArr.forEach(errorMsg => {
            const modelField = errorMsg.split('.')
            if (modelField && modelField.length > 0) {
              const model = modelMap[modelField[0]]
              if (model) {
                finalMessage += (model[modelField[1]] + suffixMsg)
              }
            } else {
              finalMessage += errorMsg
            }
          })
        }
        if (finalMessage) {
          self.$message.error({ dangerouslyUseHTMLString: true, message: finalMessage })
        } else {
          self.$message.error({ dangerouslyUseHTMLString: true, message: dataMsg })
        }
      }
      // 订舱-更正-api请求成功回调方法
      const onApiSuccess = (response, isJlx = false) => {
        if (!response || !response.data) {
          self.$message.warning(this.$t('SeaExport.ResponseDataIsEmpty'))
          return
        }
        const result = response.data
        if (result.isSuccess) {
          if (result.msg) {
            self.errorLogDialog.errorLog = result.msg
            self.errorLogDialog.visible = true
            return
          }
          self.$message.success(this.$t('SeaExport.RequestSuccessful'))
        } else {
          let text = result.text
          if (!isJlx) {
            text = text.substring(0, text.length - 5) +
              text.substring(text.length - 5, text.length).replace(';', '')
          }
          self.errorLogDialog.errorLog = text
          self.errorLogDialog.visible = true
        }
      }

      return { onExportEDISuccess, onExportEDIFail, onApiSuccess }
    },
    // 回执导入-系统文件选择change触发事件
    onImportFile(event) {
      const fileInput = this.$refs['importFile']
      const file = fileInput.files[0]
      if (file.size === 0) {
        this.$message.warning(this.$t('SeaExport.FileContentIsEmpty'))
      }
      if ((Math.round(file.size * 100 / (1024 * 1024)) / 100) > 2) {
        this.$message.warning(this.$t('SeaExport.FileSizeCannotLargerThan2MB'))
        return
      }
      savePmsFile(file).then(response => {
        if (response.data == null || response.data === '') {
          this.$message.warning(this.$t('SeaExport.FileContentWrong'))
        } else {
          this.bookingHandler().onImportSucceeded(response)
        }
      })
      fileInput.value = ''
    },
    // EDI模板选择弹窗(dialog-selector)选择数据后回调函数
    getEDICallback(row) {
      this.globalVar.ediTemplate = row
      this.globalVar.popMultiSegNumRulesType = 1
      if (this.common().checkConfig('EDINoRuleConfigMode', '1') && this.globalVar.ediType === 5) {
        this.multiSegNumRulesDialog.visible = true
      } else {
        this.multiSegNumRulesCallback(null)
      }
    },
    // 多段号码规则配置弹窗(multi-seg-num-rule-dialog)回调函数入口
    multiSegNumRulesCallback(ruleEDINos) {
      switch (this.globalVar.popMultiSegNumRulesType) {
        case 1: this.multiSegNumRulesCallbackHandler().callbackHandle1(ruleEDINos)
          break
        case 2: this.multiSegNumRulesCallbackHandler().callbackHandle2(ruleEDINos)
          break
      }
    },
    // 多段号码规则配置弹窗(multi-seg-num-rule-dialog)回调函数实际处理方法
    multiSegNumRulesCallbackHandler() {
      const self = this
      // 回调处理方法1, 订舱菜单触发多段号码规则弹窗回调函数
      const callbackHandle1 = (ruleEDINos) => {
        let ruleEDINoArr = []
        if (ruleEDINos && self.common().checkConfig('EDINoRuleConfigMode', '1') && self.globalVar.ediType === 5) {
          ruleEDINoArr = ruleEDINos
        }
        if (self.globalVar.ediTemplateWin.item) {
          self.globalVar.ediTemplateWin.item.ruleEDINos = ruleEDINoArr
          const param = {}
          param.ediType = self.globalVar.ediType
          param.templateId = self.globalVar.ediTemplate.uuid
          param.item = self.globalVar.ediTemplateWin.item
          param.editStatus = self.globalVar.editStatus
          self.loading = getLoading4Cxt(this)
          ediApi.getEDIObject(param).then(result => self.commonCallback().onExportEDISuccess(result))
            .catch(message => self.commonCallback().onExportEDIFail(message))
            .finally(() => {
              self.globalVar.ediTemplateWin.item = undefined
              self.loading.close()
            })
        } else {
          const param = {}
          param.ediType = self.globalVar.ediType
          param.templateId = self.globalVar.ediTemplate.uuid
          param.jobUuids = self.globalVar.ediTemplateWin.uuids
          param.editStatus = self.globalVar.editStatus
          param.ruleEDINos = ruleEDINoArr
          this.loading = getLoading4Cxt(this)
          ediApi.getEDI(param).then(result => self.commonCallback().onExportEDISuccess(result))
            .catch(message => self.commonCallback().onExportEDIFail(message))
            .finally(() => { self.loading.close() })
        }
      }
      // 回调处理方法2, 舱单菜单触发多段号码规则弹窗回调函数
      const callbackHandle2 = (ruleEDINos) => {
        self.shippingHandler().getShippingEDI(ruleEDINos)
      }
      return { callbackHandle1, callbackHandle2 }
    },
    // 公用方法及特殊回调方法 === <<<
    convertSendStatus(status) {
      if (!status) {
        return ''
      }
      if (status.value === 1) {
        return this.$t('SeaExport.hasBeanSend')
      } else if (status.value === 2) {
        return this.$t('Partners.deleted')
      } else if (status.value === 5) {
        return this.$t('SeaExport.HasExport')
      } else {
        return this.$t('SeaExport.notSend')
      }
    },
    // 校验数据是否符合申报格式
    async checkJobHandler(jobs) {
      const msg = []
      // 起运港loadingPort
      const polMsg = []
      // 卸货港dischargingPortCode
      const podMsg = []
      // 货物类型cargoType
      const cargoTypeMsg = []
      // 主单运输条款freightTerm
      const freightTermMsg = []
      // 贸易条款incoTerm
      const incoTermMsg = []
      // 箱型&箱种container(20GP/40GP/40HC>0)
      const containerMsg = []
      // AR费用(应收费用中，单位为20'/40'/40'HC的，币种为“USD”的含税价>0)
      const chargeMsg = []
      for (let job of jobs) {
        job = new Job(job)
        if (job.loadingPortCode !== 'CNSHA' && !polMsg.includes(job.jobNo)) {
          polMsg.push(job.jobNo)
        }
        if (job.dischargingPortCode !== 'DEHAM' && job.dischargingPortCode !== 'NLRTM' && job.dischargingPortCode !== 'BEANR' && job.dischargingPortCode !== 'GBFXT' &&
          job.dischargingPortCode !== 'FRLEH' && job.dischargingPortCode !== 'USOAK' && job.dischargingPortCode !== 'USLAX' && job.dischargingPortCode !== 'USLGB' && !podMsg.includes(job.jobNo)) {
          podMsg.push(job.jobNo)
        }
        if (job.cargoType !== 'GC' && !cargoTypeMsg.includes(job.jobNo)) {
          cargoTypeMsg.push(job.jobNo)
        }
        if (job.freightTerm !== 'CY-CY' && !freightTermMsg.includes(job.jobNo)) {
          freightTermMsg.push(job.jobNo)
        }
        if (job.incoTerm !== 'CIF' && !incoTermMsg.includes(job.jobNo)) {
          incoTermMsg.push(job.jobNo)
        }
        // 数组类型
        const containers = await job.getContainers()
        if (!containers && !containerMsg.includes(job.jobNo)) {
          containerMsg.push(job.jobNo)
        } else {
          // 有箱子，校验箱子对应的费用 :ArrayCollection
          const charges = await job.getCharges()
          if (!charges && !chargeMsg.includes(job.jobNo)) {
            chargeMsg.push(job.jobNo)
          } else {
            const containerMap = {}
            for (const c of containers) {
              if (c.eqSize === '20' && c.eqType === 'GP') {
                if (!containerMap.hasOwnProperty('20GP')) {
                  containerMap['20GP'] = 1
                } else {
                  containerMap['20GP'] = containerMap['20GP'] + 1
                }
              }
              if (c.eqSize === '40' && c.eqType === 'GP') {
                if (!containerMap.hasOwnProperty('40GP')) {
                  containerMap['40GP'] = 1
                } else {
                  containerMap['40GP'] = containerMap['40GP'] + 1
                }
              }
              if (c.eqSize === '40' && c.eqType === 'HC') {
                if (!containerMap.hasOwnProperty('40HC')) {
                  containerMap['40HC'] = 1
                } else {
                  containerMap['40HC'] = containerMap['40HC'] + 1
                }
              }
            }
            // 将费用根据单位分组统计
            const chargeMap = this.calculateReceivableCharges(charges)
            // 不包含20GP/40GP/40HC,则视为没有装箱信息
            if (!containerMap.hasOwnProperty('20GP') && !containerMap.hasOwnProperty('40GP') && !containerMap.hasOwnProperty('40HC')) {
              if (!containerMsg.includes(job.jobNo)) {
                containerMsg.push(job.jobNo)
              }
            }
            // 判断每种箱子对应的费用是否都大于0
            if ((containerMap.hasOwnProperty('20GP') && !chargeMap.hasOwnProperty('C20')) ||
              (containerMap.hasOwnProperty('40GP') && !chargeMap.hasOwnProperty('C40')) ||
              (containerMap.hasOwnProperty('40HC') && !chargeMap.hasOwnProperty('C40H'))) {
              if (!chargeMsg.includes(job.jobNo)) {
                chargeMsg.push(job.jobNo)
              }
            }
            if (containerMap.hasOwnProperty('20GP') && chargeMap.hasOwnProperty('C20')) {
              // Number类型
              const tatalC20 = chargeMap['C20']
              if (isNaN(tatalC20) || (!isNaN(tatalC20) && tatalC20 <= 0)) {
                chargeMsg.push(job.jobNo)
              }
            }
            if (containerMap.hasOwnProperty('40GP') && chargeMap.hasOwnProperty('C40')) {
              // Number类型
              const tatalC40 = chargeMap['C40']
              if (isNaN(tatalC40) || (!isNaN(tatalC40) && tatalC40 <= 0)) {
                chargeMsg.push(job.jobNo)
              }
            }
            if (containerMap.hasOwnProperty('40HC') && chargeMap.hasOwnProperty('C40H')) {
              // Number类型
              const tatalC40H = chargeMap['C40H']
              if (isNaN(tatalC40H) || (!isNaN(tatalC40H) && tatalC40H <= 0)) {
                chargeMsg.push(job.jobNo)
              }
            }
          }
        }
      }
      if (polMsg.length > 0) {
        const polMap = {}
        polMap['name'] = this.$t('SeaExport.PleaseOfDepartureMustPort')
        polMap['detail'] = polMsg
        msg.push(polMap)
      }
      if (podMsg.length > 0) {
        const podMap = {}
        podMap['name'] = this.$t('SeaExport.PleaseMustBeTheExchange')
        podMap['detail'] = podMsg
        msg.push(podMap)
      }
      if (cargoTypeMsg.length > 0) {
        const cargoTypeMap = {}
        cargoTypeMap['name'] = this.$t('SeaExport.PleaseOfGoodsMustGoods')
        cargoTypeMap['detail'] = cargoTypeMsg
        msg.push(cargoTypeMap)
      }
      if (freightTermMsg.length > 0) {
        const freightTermMap = {}
        freightTermMap['name'] = this.$t('SeaExport.PleaseOfTheMainCY')
        freightTermMap['detail'] = freightTermMsg
        msg.push(freightTermMap)
      }
      if (incoTermMsg.length > 0) {
        const incoTermMap = {}
        incoTermMap['name'] = this.$t('SeaExport.PleaseTradeTermsMustCIF')
        incoTermMap['detail'] = incoTermMsg
        msg.push(incoTermMap)
      }
      if (containerMsg.length > 0) {
        const container = {}
        container['name'] = this.$t('SeaExport.PleaseBoxQuantityInformationCorrect')
        container['detail'] = containerMsg
        msg.push(container)
      }
      if (chargeMsg.length > 0) {
        const chargeObj = {}
        chargeObj['name'] = this.$t('SeaExport.TheAmountReceivableIncludesUSD')
        chargeObj['detail'] = chargeMsg
        msg.push(chargeObj)
      }
      return msg
    },
    /**
     *  合计应收美金费用,根据箱子单位分组
     * */
    calculateReceivableCharges(charges) {
      const chargeMap = {}
      for (const charge of charges) {
        if (charge.receivable && charge.currency === 'USD') {
          if (charge.measure === 'C20') {
            if (!chargeMap.hasOwnProperty('C20')) {
              if (!isNaN(charge.amount)) {
                chargeMap['C20'] = charge.amount
              }
            } else {
              // Number类型
              const tatalAmountC20 = chargeMap['C20']
              if (!isNaN(tatalAmountC20) && !isNaN(charge.amount)) {
                chargeMap['C20'] = tatalAmountC20 + charge.amount
              }
            }
          }
          if (charge.measure === 'C40') {
            if (!chargeMap.hasOwnProperty('C40')) {
              if (!isNaN(charge.amount)) {
                chargeMap['C40'] = charge.amount
              }
            } else {
              // Number类型
              const tatalAmountC40 = chargeMap['C40']
              if (!isNaN(tatalAmountC40) && !isNaN(charge.amount)) {
                chargeMap['C40'] = tatalAmountC40 + charge.amount
              }
            }
          }
          if (charge.measure === 'C40H') {
            if (!chargeMap.hasOwnProperty('C40H')) {
              if (!isNaN(charge.amount)) {
                chargeMap['C40H'] = charge.amount
              }
            } else {
              // Number类型
              const tatalAmountC40H = chargeMap['C40H']
              if (!isNaN(tatalAmountC40H) && !isNaN(charge.amount)) {
                chargeMap['C40H'] = tatalAmountC40H + charge.amount
              }
            }
          }
        }
      }
      return chargeMap
    },
    // 分页触发时执行高级条件搜索
    pageChanged() {
      this.paginationChanged = true
      this.fetchData()
    },
    // EDI发送成功回调，更改列表中显示的发送状态
    uploadSuccess() {
      const uuid = this.selectedJob.uuid
      const rows = lodash.cloneDeep(this.rowData)
      for (const row of rows) {
        if (row.uuid === uuid) {
          switch (this.globalVar.ediType) {
            case 1:
              // 订舱EDI状态 ediBookingSendStatus 1
              row.ediBookingSendStatus = 1
              break
            case 2:
              // 提单EDI状态 ediBillSendStatus 2
              row.ediBillSendStatus = 1
              break
            case 4:
              // 安箱单EDI状态 ediInstallSendStatus 4
              row.ediInstallSendStatus = 1
              break
            case 5:
              // 舱单EDI状态 ediManifestSendStatus 5
              row.ediManifestSendStatus = 1
              break
            case 6:
              // 预配舱单EDI状态 ediShippingSendStatus 6
              row.ediShippingSendStatus = 1
              break
            case 8:
              // 反恐舱单EDI状态 ediAfrSendStatus 8
              row.ediAfrSendStatus = 1
              break
            case 30:
              // 提箱状态 ediIssuedSendStatus 30
              row.ediIssuedSendStatus = 1
              break
          }
          break
        }
      }
      this.rowData = rows
    },
    // 对接星亚E2Open系统【E2Open：ediType = 33】
    toE2Open(value) {
      switch (value) {
        case 'E2Open.origin.856.LTO':
          this.e2OpenHandler('06', '856LTO')
          break
        case 'E2Open.origin.856.CLP':
          this.e2OpenHandler('06', '856CLP')
          break
        case 'E2Open.origin.315.315EE':
          this.e2OpenHandler('06', '315EE')
          break
        case 'E2Open.origin.315.315I':
          this.e2OpenHandler('06', '315I')
          break
        case 'E2Open.origin.315.315VD':
          this.e2OpenHandler('06', '315VD')
          break
        case 'E2Open.origin.315.315ALL':
          this.e2OpenHandler('06', '315ALL')
          break
        case 'E2Open.correct.856.LTO':
          this.e2OpenHandler('05', '856LTO')
          break
        case 'E2Open.correct.856.CLP':
          this.e2OpenHandler('05', '856CLP')
          break
        case 'E2Open.correct.315.315EE':
          this.e2OpenHandler('05', '315EE')
          break
        case 'E2Open.correct.315.315I':
          this.e2OpenHandler('05', '315I')
          break
        case 'E2Open.correct.315.315VD':
          this.e2OpenHandler('05', '315VD')
          break
        case 'E2Open.correct.315.315ALL':
          this.e2OpenHandler('05', '315ALL')
          break
        case 'E2Open.delete.856.LTO':
          this.e2OpenHandler('01', '856LTO')
          break
        case 'E2Open.delete.856.CLP':
          this.e2OpenHandler('01', '856CLP')
          break
        case 'E2Open.delete.315.315EE':
          this.e2OpenHandler('01', '315EE')
          break
        case 'E2Open.delete.315.315I':
          this.e2OpenHandler('01', '315I')
          break
        case 'E2Open.delete.315.315VD':
          this.e2OpenHandler('01', '315VD')
          break
        case 'E2Open.delete.315.315ALL':
          this.e2OpenHandler('01', '315ALL')
          break
        default:
          break
      }
    },
    // status :原始【06】、更正【05】、删除【01】   sendType：报文类型【315报文、856CLP报文等】
    e2OpenHandler(status, sendType) {
      if (!status || !sendType) return
      let rows = getGridSelected(this.gridOptions)
      if ((!rows || rows.length === 0) && this.selectedJob) {
        rows = [this.selectedJob]
      }
      if (!rows || rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      if (rows.length > 100) {
        this.$message.warning(this.$t('SeaExport.checkLines100'))
        return
      }
      // 【E2Open：ediType = 33】
      const params = { anyStr: status, anyStr1: sendType, anyInteger: EdiType.E2_OPEN }
      params.keys = rows.map(item => item.uuid)
      params.branchId = this.$store.getters.currentOfficeId
      this.loading = getLoading4Cxt(this)
      ediApi.sendE2open(params).then(res => {
        const result = res.data
        if (result.success) { // 有成功
          // 已发送【变量】条，失败【变量】条
          this.$message.success(result.msg)
        } else {
          // 验证提示走这里
          if (result.checkInfo) { // 验证信息
            this.$message.error(result.checkInfo)
            return
          }
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    toShowEdiStateQueryDialog() {
      const dialog = this.ediStateQueryDialog
      dialog.title = this.$t('Message.StateQuery')
      dialog.value = this.advancedSearchForm.stateQuery || {}
      dialog.callback = data => {
        this.advancedSearchForm.stateQuery = data.value || null
        this.stateQueryTxtContent = data.txtContent
      }
      dialog.isCreate = true
      dialog.visible = true
    },
    toClearEdiStateQuery() {
      this.advancedSearchForm.stateQuery = null
      this.stateQueryTxtContent = ''
    },
    /**
     * 吉联新 原始
     * edistate 9：新增  5：修改 1：取消
     * type:请求类型
     */
    async jiLianStarAPI(ediState, type) {
      await this.common().selectedJobItemCheck()
      const loading = getLoading4Cxt(this)
      const param = {}
      param.jobUuids = this.globalVar.selectedJobKeys
      param.editStatus = parseInt(ediState)
      param.sendType = type // 订舱、预配
      param.lob = 'SE'
      ediApi.getJiLianStarAPI(param, true).then(res => {
        this.commonCallback().onApiSuccess(res)
      }).finally(() => {
        loading.close()
      })
    },
    getMingShenBookingAPI(type) {
      if (!this.globalVar.selectedJobKeys) {
        this.$message.warning(this.$t('SeaExport.PleaseSelect2'))
        return
      } else if (this.globalVar.selectedJobKeys.length > 1) {
        this.$message.warning(this.$t('SeaExport.BatchNotSupportedPleaseAgain'))
        return
      }
      if (this.globalVar.selectedJobs[0].containerLoadType !== ContainerLoadType.FCL_CARGO_TYPE.code) {
        this.$message.warning(this.$t('CargoMsg.Cargo_OnlySupportedFCL'))
        return
      }
      const param = {
        jobUuid: this.globalVar.selectedJobKeys[0],
        sendType: type
      }
      const loading = getLoading4Cxt()
      ediApi.getMingShenBookingEdiAPI(param).then(result => {
        if (result.data.success) {
          this.$message.success(this.$t('Message.SuccessfullySent'))
        } else {
          this.$message.error(result.data.message)
        }
      }).catch(message => {
        this.$message.error(message)
      }).finally(() => {
        loading.close()
      })
    },
    toContainerInfo() {
      this.apiPopup.title = this.$t('SeaExport.ContainerInfo')
      this.apiPopup.interfaceType = 5
      this.apiPopup.interfaceArray = '1'
      this.apiPopup.callback = this.getContainerInfo
      this.apiPopup.visible = true
    },
    // ens 亿通、一飞回执code转换
    ensReceipt(data) {
      const code = data.receiptCode
      const channel = data.channel
      if (channel && channel === 4) {
        if (code === 'T') {
          return this.$t('SystemMaintenance.SendSuccess')
        } else if (code === 'F') {
          return this.$t('SystemMaintenance.SendFailure')
        }
      }
      if (channel && channel === 1) {
        if (code === 'A') {
          return this.$t('SystemMaintenance.SendSuccess')
        } else if (code === 'R') {
          return this.$t('SystemMaintenance.SendFailure')
        } else if (code === 'SN') {
          return this.$t('SeaExport.Notification') + this.$t('SeaExport.Status')
        }
      }
      return data.ensSendState
    }
  }
}
</script>

<style scoped lang="scss">
.edi-triggers{
  height: 28px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  .query-toggle {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    i{
      width: 26px;
      height: 26px;
      padding: 1px 1px;
      line-height: 26px;
      background-color: #1F75D5;
      vertical-align: middle;
      border-radius: 4px;
      margin: 1px 5px;
      color: #ffffff;
      font-size: 24px;
      text-align: center;
      cursor: pointer;
      display: inline-block;
      &.down{
        transform: rotate(-90deg);
      }
      &.up{
        transform: rotate(90deg);
      }
    }
  }
  .el-menu-item{
    display: flex;
    flex-direction: row;
    .el-button--primary{
      height: 28px;
      vertical-align: text-top;
      text-align: center;
    }
  }

}
.app-main-content .grid-view .main-content ::v-deep {
  .operations .triggers > div:first-child {
    display: flex;
    .el-input {
      width: 160px;
      margin-right: 4px;
      input {
        height: 28px;
        line-height: 28px;
      }
    }
    .el-menu {
      background: transparent;
      .el-menu-item,
      .el-submenu__title {
        height: 28px;
        line-height: 28px;
        border-bottom: none;
        margin: 0 2px;
        .el-button-group {
          display: flex;
          flex-direction: row;
          .el-button--small{
            height: 28px;
            text-align: center;
            padding: 3px 1px 3px;
            span{
              vertical-align: text-top;
            }
          }
          .attach-caret-button {
            min-width: auto !important;
            margin-left: 0 !important;
            i {
              width: auto;
              margin-right: 0;
              font-size: 12px;
              color: white;
            }
          }
        }
      }
      .el-menu-item {
        padding: 0;
      }
      .el-menu-item:hover,
      .el-submenu__title:hover {
        background-color: transparent;
      }
      .el-button--mini {
        padding: 1px 1px 3px 1px;
      }
    }
  }
  .search-form {
    max-width: 1560px;
    .el-form-item__content {
      width: 215px;
      .el-date-editor {
        width: 100%;
      }
    }
    .form-item-300 {
      .el-form-item__content {
        width: 300px;
      }
    }
    .el-checkbox {
      margin-right: 5px;
      .el-checkbox__label {
        padding-left: 2px;
      }
    }
  }
  .search-form-bottom {
    .el-form-item__content {
      width: 140px;
    }
    .form-item-150 {
      .el-form-item__content {
        width: 150px;
      }
    }
    .form-item-200 {
      .el-form-item__content {
        width: 200px;
      }
    }
    .form-item-210 {
      .el-form-item__content {
        width: 210px;
      }
    }
    .form-item-525 {
      .el-form-item__content {
        width: 525px;
      }
    }
  }
}
.booking-state-statistic {
  span {
    font-size: 14px;
  }
}
</style>
